window.app = window.app || {};

if (!String.prototype.trim) {
	String.prototype.trim = function () {
		'use strict';
		return this.replace(/^\s+|\s+$/g, '');
	};
}

if (!String.prototype.format) {
	String.prototype.format = function () {
		'use strict';
		var args = arguments;
		return this.replace(/\x7b(\d+)\x7d/g, function (match, idx) {
			if (_.isUndefined(args[idx])) {
				return match;
			}
			return args[idx];
		});
	};
}

if (typeof String.prototype.startsWith !== 'function') {
	String.prototype.startsWith = function (str) {
		'use strict';
		return this.indexOf(str) === 0;
	};
}

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}

window.utils = (function () {
	'use strict';
	var utfLettersRegexString = "\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
	function alwaysFalse() {
	    return false;
    }
	function notEmpty(value) {
		return !!(value && value.trim() !== '');
	}
	function minlength(value, params) {
		var isValid = ((value || '').trim().length >= params.min);
		if (!isValid) {
			params.message = params.message.replace('{0}', params.min);
		}
		return isValid;
	}
	function maxlength(value, params) {
		var isValid = ((value || '').trim().length <= params.max);
		if (!isValid) {
			params.message = params.message.replace('{0}', params.max);
		}
		return isValid;
	}
	function exactlength(value, params) {
		var isValid = ((value || '').trim().length == params.len);
		if (!isValid) {
			params.message = params.message.replace('{0}', params.len);
		}
		return isValid;
	}
	function exactlengthCompositePhoneWithoutCode(value, params) {
		var numberPart = (value || "").trim().split("-")[1] || "";
		return exactlength(numberPart, params);
	}
	function digitsOnly(value) {
		return /^\d+$/.test(value);
	}

	function digitsOnlyOrEmpty(value) {
		return /^\d*$/.test(value);
	}

	function alphanumeric(value) {
		return /^[a-zA-Z0-9]+$/.test(value);
	}
	function inRange(value, params) {
		var normValue = parseFloat(value);
		var isValid = ( normValue <= params.max && normValue >= params.min);
		if(params.minMsg && normValue < params.min) {
			params.message = params.minMsg;
		} else if (params.maxMsg) {
			params.message = params.maxMsg;
		}
		params.message = params.message
			.replace('{0}', params.formatter.formatCurrency(params.min, params.currencyIso))
			.replace('{1}', params.formatter.formatCurrency(params.max, params.currencyIso));
		return isValid;
	}
	function maxAmount(value, params) {
		var normValue = parseFloat(value);
		var isValid = ( normValue <= params.max );
		params.message = params.message.replace('{0}', params.formatter.formatCurrency(params.max, params.currencyIso));
		return isValid;
	}
	function nonZeroNumberStart(value) {
		var startWithZero = /^0+[1-9]+/;
		return !startWithZero.test(value + '');
	}
	function atLeastTwoNonZeroDigits(value) {
		if(value.replace(/0/g, '').length > 1) {
			return true;
		} else {
			return false;
		}
	}
	function fortunaMod11ChechBanks(number) {
		var weights = [6,3,7,9,10,5,8,4,2,1].reverse();
		var numberAsArray = number.split("").reverse();
		var sum = 0;
		if(number.length > 10) { 
			return false;
		} else {
			for(var i = 0; i < numberAsArray.length; i++){
				sum += parseInt(numberAsArray[i]) * parseInt(weights[i]);
			}
			var result = sum % 11;
			return (result === 0);
		}
	}
	function cc_minlength(value, params) {
		var normValue = value.replace(/\s/g, '').trim();
		var isValid = (normValue.length >= params.min);
		if (!isValid) {
			params.message = params.message.replace('{0}', params.min);
		}
		return isValid;
	}
	function cc_maxlength(value, params) {
		var normValue = value.replace(/\s/g, '').trim();
		var isValid = (normValue.length <= params.max);
		if (!isValid) {
			params.message = params.message.replace('{0}', params.max);
		}
		return isValid;
	}
	function cc_expiration(value) {
		var now = (new Date()).getTime();
		return value.getTime() > now;
	}
	function _isValidShortIsraeliCard( cardNumber ) {
		var sum       = 0;
		var cc_number = cardNumber.replace(/\D/g, '');
		var length    = cc_number.length;
		if (length < 8 || length > 9) {
			return false;
		}
		for ( var i = 0; i < length; i++) {
			sum += ( parseInt(cc_number.charAt(i), 10) * (length - i) );
		}
		return (sum % 11) == 0;
	}
	function creditcard(cardNumber) {
		var nCheck  = 0,
			bEven   = false;
		var value   = cardNumber.replace(/\D/g, '');
		var length  = value.length;
		if (length == 8 || length == 9) {
			return  _isValidShortIsraeliCard( cardNumber );
		}
		for (var n = length - 1; n >= 0; n--) {
			var cDigit = value.charAt(n);
			var nDigit = parseInt(cDigit, 10);
			if (bEven) {
				if ((nDigit *= 2) > 9)
					nDigit -= 9;
			}
			nCheck += nDigit;
			bEven = !bEven;
		}

		return (nCheck % 10) == 0;
	}

	function _isAcceptableCardNumber(value, params) {
		var invalidCards = [/44444444\d+/, /55555555\d+/, /66666666\d+/];
		var validCards = params && params.isAstropayPrePaid ? /[1-6]\d+/ : /[2-6]\d+/;
		var isValid = true;
		var normValue = value.replace(/ /g, '');
		if (normValue.length !== 8 && normValue.length !== 9) {
			for (var i = 0; i < invalidCards.length; i++) {
				if (invalidCards[i].test(normValue)) {
					isValid = false;
				}
			}
			isValid = isValid && validCards.test(value);
		}
		return isValid;
	}

	function _isAllowedCardIssuer(card_number, params) {
		var isValid = true;
		var invalidCardIssuers = params.invalidCardIssuers || [];
		for (var idx = 0; idx < invalidCardIssuers.length; idx++) {
			if (invalidCardIssuers[idx] === params.cc_brand) {
				isValid = false;
				break;
			}
		}
		return isValid;
	}

	function _isValidCardIssuer(card_number, params) {
		var isValid = true;
		var cardInfo = params.cardInfo && params.cardInfo.is_dual_brand && app.util.asyncCheck.getCardInfo(card_number);
		if (cardInfo && cardInfo.isDualBrand) {
			if (!cardInfo.isBrand1Allowed && !cardInfo.isBrand2Allowed) {
				isValid = false;
			}
			else if (params.validCardIssuers) {
				isValid = cardInfo.isBrand1Allowed && params.validCardIssuers[cardInfo.cardBrand];
				isValid = isValid ? isValid : cardInfo.isBrand2Allowed && params.validCardIssuers[cardInfo.cardBrand2];
			}
		}
		else if (params.slave_cc_brand && params.validCardIssuers
			&& !params.validCardIssuers[params.slave_cc_brand]) {
			isValid = false;
		}
		return isValid;
	}

	function _isValidCardIssuerCountry(card_number, params) {
		var isValid = true;
		var cardInfo;
		if (!_.isEmpty(params.allowedCardCountries)) {
			cardInfo = app.util.asyncCheck.getCardInfo(card_number);
			if (cardInfo && params.allowedCardCountries.indexOf(cardInfo.issuerCountry) < 0) {
				params._cardIssuerCountry = cardInfo.issuerCountry;
				isValid = false;
			}
		}
		return isValid;
	}

	function _isCurrencySupportedByTheCard(card_number, params) {
		var isValid = true;
		var currencyIso = params.dccCurrencyIso || params.currencyIso;
		if (params.cardSupportedCurrencies && currencyIso
			&& params.cardSupportedCurrencies[params.cc_brand]
			&& !params.cardSupportedCurrencies[params.cc_brand][currencyIso]) {
			isValid = false;
		}
		return isValid;
	}

	function isCardAcceptable(value, params) {
		var isValid = _isAcceptableCardNumber(value, params);

		if (isValid && !_isAllowedCardIssuer(value, params)) {
			isValid = false;
			params.message = (params.restrictedCCMsg || '').replace('{0}', params.cc_brand_label);
		}

		if (isValid && !_isValidCardIssuer(value, params)) {
			isValid = false;
			params.message = (params.allowedCCMsg || '').replace('{0}', params.slave_cc_brand_label);
		}

		if (isValid && !_isValidCardIssuerCountry(value, params)) {
			isValid = false;
			var country = app.allCountries ? app.allCountries.find(function(c) {
				return c.iso === params._cardIssuerCountry;
			}) : params._cardIssuerCountry;
			params.message = (params.restrictedCCCountryMsg || '').replace('{0}', country ? country.name || country : '');
		}

		if (isValid && !_isCurrencySupportedByTheCard(value, params)) {
			isValid = false;
			var cSymbol =  params.formatter.getCurrencySymbol(params.currencyIso);
			params.message = (params.restrictedCCCurrencyMsg || '').replace('{0}', cSymbol);
		}
		return isValid;
	}
	function isCurrencySupportedByTheCard(value, params)	{
		var isValid = true;
		if (!_isCurrencySupportedByTheCard(value, params)) {
			isValid = false;
			var cSymbol =  params.formatter.getCurrencySymbol(params.currencyIso);
			params.message = (params.restrictedCCCurrencyMsg || '').replace('{0}', cSymbol);
		}

		return isValid;
	}

	function isValidCardNumber(value, params) {
		var isValid = _isAcceptableCardNumber(value, params);
		isValid = isValid && creditcard(value);
		isValid = isValid && _isAllowedCardIssuer(value, params);
		isValid = isValid && _isValidCardIssuer(value, params);
		return isValid;
	}

	function isCardNumber(value, params) {
		var isValid = _isAcceptableCardNumber(value, params);
		isValid = isValid && creditcard(value);
		return isValid;
	}

	function asyncCheck(value, params) {
		var isValid = true, err;
		try {
			err = params.fn(value);
		} catch (e) {
		}
		if (err) {
			isValid = false;
			if (params['restricted_' + err.code + 'Msg']) {
				params.message = params['restricted_' + err.code + 'Msg'].replace('{0}', err.val);
			} else {
				params.message = err.text;
			}
		}
		else {
			isValid = _hasAllowedBrand(value, params);
			if (!isValid) {
				params.message = params.restricted_bothBrandsMsg;
			}
		}
		return isValid;
	}

	function _hasAllowedBrand(value, params) {
		var isValid = true;
		var cardInfo = app.util.asyncCheck.getCardInfo(value);
		if (cardInfo && cardInfo.isDualBrand && !cardInfo.isBrand1Allowed && !cardInfo.isBrand2Allowed) {
			isValid = false;
		}
		return isValid;
	}

	function exceedsCreditCardDepositLimit(amount, params) {
		var isValid = true;
		if (app.config.maxCreditCardDepositBalance && app._flag.isCurrentCardCredit) {
			var totalAmount = (app.config.creditCardDepositBalance || 0) + parseFloat(amount);
			if (totalAmount > app.config.maxCreditCardDepositBalance) {
				isValid = false;
			}
		}
		return isValid;
	}

	function testPlayPlusBalance(amount, params) {
		var isValid = true;
		var balance;

		function getBalance(currentFields) {
			if (currentFields.sightline_balanceButton) {
				return currentFields.sightline_balanceButton.value;
			}

			if (currentFields._extraData && currentFields._extraData.sightline_balanceButton) {
				return currentFields._extraData.sightline_balanceButton.value;
			}

			return "";
		}

		if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.PLAY_PLUS) {
			balance = getBalance(app.currentMethodFields);

			if (app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance &&
					balance === '' &&
					!app.util.isUpo(app.lastSelectedMethodId)) {
				isValid = false;
				params.message = params.notEnrolledMsg;
			} else if (balance && !isNaN(balance) && parseFloat(amount) > parseFloat(balance)) {
				isValid = false;
			}
		}

		return isValid;
	}

	function testOktoCashDecimalAmount(value, params) {
		var currenciesWithoutDecimals = ["CZK", "RSD"];
		if (
			app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.OKTO_CASH &&
			currenciesWithoutDecimals.includes(params.currencyIso)
		) {
			return digitsOnly(parseFloat(value));
		}
		return true;
	}

	function validNettelerAccount(value) {
		value = value || '';
		var normValue = value.trim();
		var emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var isValidEmail = emailRe.test(normValue);
		if (isValidEmail) {
			return true;
		} else {
			var numRe = /^\d{12}$/;
			return numRe.test(normValue);
		}
	}
	function testAstroPayPhone(value) {
		value = value || '';
		var normValue = value.trim();
		var r = /^[\d]{5,18}$/; // ???  /^[\d+()\/\\\-\*\.\s]{5,18}$/;
		return r.test(normValue);
	}
	function testAstroPayPrepaidAccountId(value) {
		value = value || '';
		var normValue = value.trim();
		var isValidEmail = testEmail(normValue);
		if (isValidEmail) {
			return true;
		} else {
			return testAstroPayPhone(value);
		}
	}
	function testRegex(value, params) {
		value = value || '';
		return params.regex.test(value);
	}
	function testZip(value, params) {
			var r = /^[\s\w\/\-\\]{1,10}$/; // CASH-498 20->10 char.  //	/^[\w| \d|-]*$/;
			return r.test(value);
	}
	function testEcheckZip(value, params) {
		return value && value.length === 6 && alphanumeric(value);
	}
	function testDateOfBirth(value) {
		if(typeof value !== 'string') {
			return false;
		}
		
		if(value.length !== 10) {
			return false
		}

		var value = value.split('-');
		if(value.length !== 3) {
			return false;
		}

		var yyyy = value[0],
			mm = value[1],
			dd = value[2],
			isValid = true;

		if(yyyy && mm && dd) {
			var dateOfBirth = new Date(yyyy, mm - 1, dd);

			if(isNaN(dateOfBirth)) {
				isValid = false;
			} else {
				var	minAge = 14,
					maxAge = 130,
					dateOfBirthYear = dateOfBirth.getFullYear(),
					monthStr =  (dateOfBirth.getMonth() + 1).toString(),
					dateStr = dateOfBirth.getDate().toString(),
					currentYear = new Date().getFullYear(),
					isValidYear = dateOfBirthYear && dateOfBirthYear.toString() === yyyy,
					isValidMonth = (monthStr.length > 1 ? monthStr : '0' + monthStr) === mm,
					isValidDate = (dateStr.length > 1  ? dateStr : '0' + dateStr) === dd;

				if(
					!isValidYear || 
					!isValidMonth || 
					!isValidDate ||
					!(currentYear - dateOfBirthYear > minAge) ||
					!(currentYear - dateOfBirthYear < maxAge)
				) {
					isValid = false;
				}
			}
		} else {
			isValid = false;
		}
		
		return isValid;
	}
	function testEcheckState(value, params) {
		if (value.length !== 2) {
			return false;
		}
		var firstCharacter = value.charCodeAt(0),
			secondCharacter = value.charCodeAt(1);
		if (firstCharacter > 90 || firstCharacter < 65 || secondCharacter > 90 || secondCharacter < 65) {
			return false;
		}
		return true;
	}
	function testEcheckCountry(value, params) {
		return (value && value === "CA")
	}
	function testAddress(value) {
		var value_trimmed = (value || '').trim();
		var regexString = "^[" + utfLettersRegexString + "\\s\\w\\/,\\\.#&0-9\\-\']{1,160}$";
		//var regexString = "^[\w\/\s,\\.#&\-]{1,160}$";
		var r = new RegExp(regexString);    // CASH-799
		return r.test(value_trimmed);
	}
	function testCVV2 (value, params, cc_type) {
		var len     = 3;
		var isValid = false;
		var value_trimmed = (value || '').trim();
		cc_type = cc_type || params.cc_type;
		if(cc_type == 'none')  {
			isValid = (value_trimmed.length == 3  || value_trimmed.length == 4);
			params.message = params.alt_message;
		} else if(cc_type == 'amex' || cc_type == 'astropay_card') {
			len = 4;
			isValid = (value_trimmed.length == len);
		} else if (cc_type == 'maestro') {
			isValid = ((value_trimmed.length == 3) || (value_trimmed.length == 0));
		} else {
			isValid = (value_trimmed.length == 3);
		}
		isValid = isValid && (/^\d+$/.test(value) || (cc_type == 'maestro' && value === ''));
		if (!isValid) {
			params.message = params.message.replace('{0}', len);
		}
		return isValid;
	}
	function testIBAN(iban) {
		var startsWithLettersRegex = /^[A-Z]{2}/;

		if(typeof iban !== 'string' || iban.match(/[^a-zA-Z\d]/g) || iban.length < 9 || !startsWithLettersRegex.test(iban)) {
			return false;
		}

		var belgianIBANCheck = true;
		if (iban.toUpperCase().slice(0,2) === "BE") {
			belgianIBANCheck = digitsOnly(iban.slice(2)) && iban.length === 16;
		}

		var	ibanCheck = iban.toUpperCase().slice(4, iban.length) + iban.slice(0, 4),
			charCodeOfA  = 'A'.charCodeAt(0),
			charCodeOfZ = 'Z'.charCodeAt(0);
		
		ibanCheck = ibanCheck.split('').map(function (char) {
			var currentCharCode = char.charCodeAt(0);
	
			if (currentCharCode >= charCodeOfA && currentCharCode <= charCodeOfZ) {
				return currentCharCode - charCodeOfA + 10;
			} else {
				return char;
			}
		}).join('');
		
		while (ibanCheck.length > 2) {
			var section = ibanCheck.slice(0, 9);
			ibanCheck = parseInt(section, 10) % 97 + ibanCheck.slice(section.length);
		}
	
	
		return (parseInt(ibanCheck, 10) % 97 === 1 && belgianIBANCheck);
	}
	function testIBANWithSpacesInsensitive(iban) {
		var iban = (iban || "").toUpperCase().replace(/ /g, "");
		return testIBAN(iban);
	}
	function testWebanqAccountId (value) {
		var r = /^WB[0-9]{7,13}$/;
		return r.test(value);
	}
	function testWebanqAccountPassword (value) {
		var r = /^[a-zA-Z0-9]{7,32}$/;
		return r.test(value);
	}
	function noCommaSeparatedNumber(value) {
		var noCommaSeparatedReg = /^[0-9]\d{0,6}((\.)\d{1,2})?$/g;
		return noCommaSeparatedReg.test(value);
	}
	function testEmail(value) {
		value = value || '';
		var normValue = value.trim();
		var emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRe.test(normValue);
	}
	function testFullName(value) {
		return /^[a-zA-Z\s\-]+$/.test(value);
	}
	function testPaySafeName (value) {
		var r = /^[a-zA-Z\s\.\,\-]{1,40}$/;
		return r.test(value);
	}
	function testPaySafeBirthdate (value) {
		var r = /^((19|20)[\d]{2}\-(0[1-9]|1[0-2])\-(0[1-9]|1[0-9]|2[0-9]|3[0-1]))$/;
		return r.test(value);
	}
	function recognizedIssuer (value) {
		var strippedValue = value.split(' ').join('');
		return checkCardType(strippedValue) !== 'none';
	}
	function testQiwiPhonenumber (value) {
		var r = /^[1-9]\d*$/;
		return r.test(value);
	}
	function testLPEAccountNumber(value, params) {
		var normValue = (value || '').trim();
		var countryRegex = {
			"SW": /^[0-9]{1,15}$/,
			"GB": /^[0-9]{8}$/
		}
		var regex = countryRegex[params.country];
		return regex ? regex.test(normValue) : true;
	}
	function testLPEBankNumber(value, params) {
		var normValue = (value || '').trim();
		var countryRegex = {
			"SW": /^[0-9]{4,5}$/,
			"GB": /^[0-9]{6}$/
		}
		var regex = countryRegex[params.country];
		return regex ? regex.test(normValue) : true;
	}
	function testPhonenumber (value, params) {
		var normValue = (value || '').trim();
		if (normValue.length === 0 || normValue.length > 18 ) {
			return false;
		}
		//var r = /^[\d\/\-\+]+$/; //v5
		var r = /^[\d+()\/\\\-\*\.\s]*$/; //v3
		return r.test(normValue);
	}
	function testCompositePhone(value, params) {
		var normValue = (value || '').trim();
		var split = normValue.split('-');
		var countryCode = split[0];
		var phoneNumber = split[1];

		return (countryCode && digitsOnly(countryCode) && phoneNumber && digitsOnly(phoneNumber)) &&
			testPhonenumber(normValue.replace('-',''), params);
	}
	function testSmart2PayPhonenumber(value, params) {
		var normValue = (value || '').trim();
		var r = /^\+\d{1,15}$/;
		return r.test(normValue);
	}
	function testMbwayPhoneNumber(value, params) {
		var normValue = (value || '').trim();
		var r = /^351\-9[01236][0-9]{7}$/;
		return r.test(normValue);
	}
	function testBrazilPersonalId(value) {
		var isCPFValid = false;
		var blackList = {
			"11111111111": 1, "22222222222": 1, "33333333333": 1, "44444444444": 1, "55555555555": 1,
			"66666666666": 1, "77777777777": 1, "88888888888": 1, "99999999999": 1, "00000000000": 1
		}
		value = (value || '').replace(/\D/g, '');
		if (value.length === 11 && !blackList[value]) {
			var normValue = value.split('').slice(0, 9);
			var checkDigit1 = 0;
			var checkDigit2 = 0;
			var weight = 2;
			for (var i = normValue.length - 1; i >= 0; i--) {
				checkDigit1 = checkDigit1 + weight*normValue[i];
				checkDigit2 = checkDigit2 + (weight + 1)*normValue[i];
				weight = weight + 1;
			}
			checkDigit1 = (checkDigit1 % 11) < 2 ? 0 : 11 - (checkDigit1 % 11);
			checkDigit2 = checkDigit2 + 2*checkDigit1;
			checkDigit2 = (checkDigit2 % 11) < 2 ? 0 : 11 - (checkDigit2 % 11);
			normValue.push(checkDigit1, checkDigit2);
			isCPFValid = (normValue.join("") === value);
		}
		return isCPFValid;
	}
	function testPersonalId(value, params) {
		var normValue = (value || '').trim();
		var len = ('' + normValue).length;
		var isValid = true;
		if (params.country == 'AR') {                                                   // Argentina        Length 7-9 or 11 numeric
			isValid = digitsOnly(normValue) && (len == 11 || (len > 6 && len < 10));
		} else if (params.country == 'BR') {                                            // Brazil           Length 11 or 14 numeric
			isValid = digitsOnly(normValue) && (len == 11 || len == 14) && testBrazilPersonalId(normValue);
		} else if (params.country == 'CL') {                  							// Chile       		12345678, 123456789, 12345678k, 12345678K
			isValid = /^[0-9]{8}(?:[0-9K])?$/i.test(normValue);
		} else if (params.country == 'PE') {											// Peru				Length 8-9 numeric
			isValid = digitsOnly(normValue) && (len == 8 || len == 9);
		} else if (params.country == 'CO') {                                            // Colombia         length between 6 and 10 numeric
			isValid = digitsOnly(normValue) && (len > 5 && len < 11);
		} else if (params.country == 'MX') {                                            // Mexico           length between 10 and 18 <alphanumeric/>
			isValid = alphanumeric(normValue) && (len > 9 && len < 19);
		} else if (params.country == 'PY' || params.country == 'UY') {                  // Paraguay/Uruguay Length 6-8  numeric
			isValid = digitsOnly(normValue) && (len > 5 && len < 9);
		}
		return isValid;
	}
	function testCitadelSwiftCode (value) {
		var r =  /^[A-Za-z]{6}[A-Za-z0-9]{2,5}$/;
		return r.test(value);
	}
	function dateInThePast(value) {
		var valueAsArray = value.split("-"); //// YYYY-MM-DD
		var valueAsDate  = new Date(valueAsArray[0], valueAsArray[1] - 1, valueAsArray[2]);
		var now = (new Date()).getTime();
		return valueAsDate.getTime() < now;
	}
	function testInstadebitAccountId (value) {
		var r = /^[A-Z0-9\-\+]{1,30}$/;
		return r.test(value);
	}
	function testPromoCode (value) {
		var r = /^[A-Za-z0-9\-\+\.\_]{0,10}$/;
		return r.test(value);
	}
    function validateCardHolderName(value) {
		// var dankortCharsStr = "\\u00C6\\u00D8\\u00C5\\u00E6\\u00F8\\u00E5"; // "ÆØÅæøå";
        // var matchResult = value.match(/^[ a-zA-Z!\"#$%&.\'(*+,-:;<=>?:;<=>?@\[\]\\\u0590-\u05FF\uFB1E-\uFB4F\u00C6\u00D8\u00C5\u00E6\u00F8\u00E5\u00c0-\u017e]+$/g); // previous validation
		// matches all Chinese, Japanese and German chars
        //var matchResult = value.match(/^[ a-zA-Z!\"#$%&.\'(*+,-:;<=>?:;<=>?@\[\]\\\u0590-\u05FF\uFB1E-\uFB4F\u00C6\u00D8\u00C5\u00E6\u00F8\u00E5\u00c0-\u017e\u2E80-\u2EF3\u2F00-\u2FD5\u3000-\u303F\u31C0-\u31E3\u3200-\u32FF\u3400-\u4DB5\u4E00-\u4FFF]+$/g);
        var matchResult = value.match(/[\^_~\\\/<>\[\]{}]+/g); // excludes these symbols, to change that uncomment one of the previous match results and remove ! sign from if(!matchResult)
        value = value.replace(/[\s]/g, "");
		if (!matchResult) {
            if (
				value.match(/[\d]{4,}/) ||
				value.match(/^[0-9]{1,3}$/)
			) {
				return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
	function validateCardHolderNameOnWD(value) {
		var validCharacters = {
			//ASCII 33-126
			"!" : 1, '"' : 1, "#" : 1, "$" : 1, "%" : 1, "&" : 1, "'" : 1, "(" : 1, ")" : 1,
			"*" : 1, "+" : 1, "," : 1, "-" : 1, "." : 1, "/" : 1, "0" : 1, "1" : 1, "2" : 1,
			"3" : 1, "4" : 1, "5" : 1, "6" : 1, "7" : 1, "8" : 1, "9" : 1, ":" : 1, ";" : 1,
			"<" : 1, "=" : 1, ">" : 1, "?" : 1, "@" : 1, "A" : 1, "B" : 1, "C" : 1, "D" : 1,
			"E" : 1, "F" : 1, "G" : 1, "H" : 1,	"I" : 1, "J" : 1, "K" : 1, "L" : 1, "M" : 1,
			"N" : 1, "O" : 1, "P" : 1, "Q" : 1, "R" : 1, "S" : 1, "T" : 1, "U" : 1, "V" : 1,
			"W" : 1, "X" : 1, "Y" : 1, "Z" : 1, "[" : 1, "\\" : 1, "]" : 1, "^" : 1, "_" : 1,
			"`" : 1, "a" : 1, "b" : 1, "c" : 1, "d" : 1, "e" : 1, "f" : 1, "g" : 1, "h" : 1,
			"i" : 1, "j" : 1, "k" : 1, "l" : 1, "m" : 1, "n" : 1, "o" : 1, "p" : 1, "q" : 1,
			"r" : 1, "s" : 1, "t" : 1, "u" : 1, "v" : 1, "w" : 1, "x" : 1, "y" : 1, "z" : 1,
			"{" : 1, "|" : 1, "}" : 1, "~" : 1,
			//Other valid characters
			"æ" : 1, "ǽ" : 1, "ö" : 1, "œ" : 1, "À" : 1, "Á" : 1, "Â" : 1, "Ã" : 1, "Å" : 1,
			"Ǻ" : 1, "Ā" : 1, "Ă" : 1, "Ą" : 1, "Ǎ" : 1, "Α" : 1, "Ά" : 1, "Ả" : 1, "Ạ" : 1,
			"Ầ" : 1, "Ẫ" : 1, "Ẩ" : 1, "Ậ" : 1, "Ằ" : 1, "Ắ" : 1, "Ẵ" : 1, "Ẳ" : 1, "Ặ" : 1,
			"А" : 1, "à" : 1, "á" : 1, "â" : 1, "ã" : 1, "å" : 1, "ǻ" : 1, "ā" : 1, "ă" : 1,
			"ą" : 1, "ǎ" : 1, "ª" : 1, "α" : 1, "ά" : 1, "ả" : 1, "ạ" : 1, "ầ" : 1, "ấ" : 1,
			"ẫ" : 1, "ẩ" : 1, "ậ" : 1, "ằ" : 1, "ắ" : 1, "ẵ" : 1, "ẳ" : 1, "ặ" : 1, "а" : 1,
			"Б" : 1, "Ç" : 1, "Ć" : 1, "Ĉ" : 1, "Ċ" : 1, "Č" : 1, "ç" : 1, "ć" : 1, "ĉ" : 1,
			"ċ" : 1, "č" : 1, "Д" : 1, "д" : 1, "Đ" : 1, "Δ" : 1, "đ" : 1, "δ" : 1, "È" : 1,
			"É" : 1, "Ê" : 1, "Ë" : 1, "Ē" : 1, "Ĕ" : 1, "Ė" : 1, "Ę" : 1, "Ě" : 1, "Ε" : 1,
			"Έ" : 1, "Ẽ" : 1, "Ẻ" : 1, "Ẹ" : 1, "Ề" : 1, "Ế" : 1, "Ễ" : 1, "Ể" : 1, "Ệ" : 1,
			"Е" : 1, "Э" : 1, "è" : 1, "é" : 1, "ê" : 1, "ë" : 1, "ē" : 1, "ĕ" : 1, "ė" : 1,
			"ę" : 1, "ě" : 1, "έ" : 1, "ε" : 1, "ẽ" : 1, "ẻ" : 1, "ẹ" : 1, "ề" : 1, "ế" : 1,
			"ễ" : 1, "ể" : 1, "ệ" : 1, "е" : 1, "э" : 1, "Ф" : 1, "ф" : 1, "Ĝ" : 1, "Ğ" : 1,
			"Ġ" : 1, "Ģ" : 1, "Γ" : 1, "Г" : 1, "Ґ" : 1, "ĝ" : 1, "ğ" : 1, "ġ" : 1, "ģ" : 1,
			"γ" : 1, "г" : 1, "ґ" : 1, "Ĥ" : 1, "Ħ" : 1, "ĥ" : 1, "ħ" : 1, "Ì" : 1, "Í" : 1,
			"Î" : 1, "Ï" : 1, "Ĩ" : 1, "Ī" : 1, "Ĭ" : 1, "Ǐ" : 1, "Į" : 1, "İ" : 1, "Η" : 1,
			"Ή" : 1, "Ί" : 1, "Ι" : 1, "Ϊ" : 1, "Ỉ" : 1, "Ị" : 1, "И" : 1, "Ы" : 1, "ì" : 1,
			"í" : 1, "î" : 1, "ï" : 1, "ĩ" : 1, "ī" : 1, "ĭ" : 1, "ǐ" : 1, "į" : 1, "ı" : 1,
			"η" : 1, "ή" : 1, "ί" : 1, "ι" : 1, "ϊ" : 1, "ỉ" : 1, "ị" : 1, "и" : 1, "ы" : 1,
			"ї" : 1, "Ĵ" : 1, "ĵ" : 1, "Ķ" : 1, "Κ" : 1, "К" : 1, "ķ" : 1, "κ" : 1, "к" : 1,
			"Ĺ" : 1, "Ļ" : 1, "Ľ" : 1, "Ŀ" : 1, "Ł" : 1, "Λ" : 1, "Л" : 1, "ĺ" : 1, "ļ" : 1,
			"ľ" : 1, "ŀ" : 1, "ł" : 1, "λ" : 1, "л" : 1, "М" : 1, "м" : 1, "Ñ" : 1, "Ń" : 1,
			"Ņ" : 1, "Ň" : 1, "Ν" : 1, "Н" : 1, "ñ" : 1, "ń" : 1, "ņ" : 1, "ň" : 1, "ŉ" : 1,
			"ν" : 1, "н" : 1, "Ò" : 1, "Ó" : 1, "Ô" : 1, "Õ" : 1, "Ō" : 1, "Ŏ" : 1, "Ǒ" : 1,
			"Ő" : 1, "Ơ" : 1, "Ø" : 1, "Ǿ" : 1, "Ο" : 1, "Ό" : 1, "Ω" : 1, "Ώ" : 1, "Ỏ" : 1,
			"Ọ" : 1, "Ồ" : 1, "Ố" : 1, "Ỗ" : 1, "Ổ" : 1, "Ộ" : 1, "Ờ" : 1, "Ớ" : 1, "Ỡ" : 1,
			"Ở" : 1, "Ợ" : 1, "О" : 1, "ò" : 1, "ó" : 1, "ô" : 1, "õ" : 1, "ō" : 1, "ŏ" : 1,
			"ǒ" : 1, "ő" : 1, "ơ" : 1, "ø" : 1, "ǿ" : 1, "º" : 1, "ο" : 1, "ό" : 1, "ω" : 1,
			"ώ" : 1, "ỏ" : 1, "ọ" : 1, "ồ" : 1, "ố" : 1, "ỗ" : 1, "ổ" : 1, "ộ" : 1, "ờ" : 1,
			"ớ" : 1, "ỡ" : 1, "ở" : 1, "ợ" : 1, "о" : 1, "П" : 1, "п" : 1, "Ŕ" : 1, "Ŗ" : 1,
			"Ř" : 1, "Ρ" : 1, "Р" : 1, "ŕ" : 1, "ŗ" : 1, "ř" : 1, "ρ" : 1, "р" : 1, "Ś" : 1,
			"Ŝ" : 1, "Ş" : 1, "Ș" : 1, "Š" : 1, "Σ" : 1, "С" : 1, "ś" : 1, "ŝ" : 1, "ş" : 1,
			"ș" : 1, "š" : 1, "ſ" : 1, "σ" : 1, "ς" : 1, "с" : 1, "Ț" : 1, "Ţ" : 1, "Ť" : 1,
			"Ŧ" : 1, "τ" : 1, "Т" : 1, "ț" : 1, "ţ" : 1, "ť" : 1, "ŧ" : 1, "т" : 1, "Ù" : 1,
			"Ú" : 1, "Û" : 1, "Ũ" : 1, "Ū" : 1, "Ŭ" : 1, "Ů" : 1, "Ű" : 1, "Ų" : 1, "Ư" : 1,
			"Ǔ" : 1, "Ǖ" : 1, "Ǘ" : 1, "Ǚ" : 1, "Ǜ" : 1, "Ủ" : 1, "Ụ" : 1, "Ừ" : 1, "Ứ" : 1,
			"Ữ" : 1, "Ử" : 1, "Ự" : 1, "У" : 1, "ù" : 1, "ú" : 1, "û" : 1, "ũ" : 1, "ū" : 1,
			"ŭ" : 1, "ů" : 1, "ű" : 1, "ų" : 1, "ư" : 1, "ǔ" : 1, "ǖ" : 1, "ǘ" : 1, "ǚ" : 1,
			"ǜ" : 1, "υ" : 1, "ύ" : 1, "ϋ" : 1, "ủ" : 1, "ụ" : 1, "ừ" : 1, "ứ" : 1, "ữ" : 1,
			"ử" : 1, "ự" : 1, "у" : 1, "Ý" : 1, "Ÿ" : 1, "Ŷ" : 1, "Υ" : 1, "Ύ" : 1, "Ϋ" : 1,
			"Ỳ" : 1, "Ỹ" : 1, "Ỷ" : 1, "Ỵ" : 1, "Й" : 1, "ý" : 1, "ÿ" : 1, "ŷ" : 1, "ỳ" : 1,
			"ỹ" : 1, "ỷ" : 1, "ỵ" : 1, "й" : 1, "В" : 1, "в" : 1, "Ŵ" : 1, "ŵ" : 1, "Ź" : 1,
			"Ż" : 1, "Ž" : 1, "Ζ" : 1, "З" : 1, "ź" : 1, "ż" : 1, "ž" : 1, "ζ" : 1, "з" : 1,
			"Æ" : 1, "Ǽ" : 1, "Ĳ" : 1, "ĳ" : 1, "Œ" : 1, "ƒ" : 1, "ξ" : 1, "π" : 1, "β" : 1,
			"μ" : 1, "ψ" : 1, "Ё" : 1, "ё" : 1, "Є" : 1, "є" : 1, "Ї" : 1, "Ж" : 1, "ж" : 1,
			"Х" : 1, "х" : 1, "Ц" : 1, "ц" : 1, "Ч" : 1, "ч" : 1, "Ш" : 1, "ш" : 1, "Щ" : 1,
			"щ" : 1, "Ю" : 1, "ю" : 1, "Я" : 1, "я" : 1, "Þ" : 1, "þ" : 1, "Ð" : 1, "ð" : 1,
			"ß" : 1, "Ö" : 1, "Ü" : 1, "ü" : 1, "Ä" : 1, "ä" : 1, "Ď" : 1, "ď" : 1,
		};
		value = value.replace(/[\s]/g, "");
		if (
			value.match(/[\d]{4,}/) ||
			value.match(/^[0-9]{1,3}$/)
		) {
			return false;
		} else {
			for (var n = 0; n <= value.length - 1; n++) {
				if (!validCharacters[value[n]]) {
					return false;
				}
			}
		}
		return true;
    }
	function testIsraeliCardHolderID(value) {
		if ( !value || /[^0-9\s]+/.test(value) || value.replace(' ', '').length > 9) {
			return false;
		}
		var nCheck = 0, nDigit = 0, bEven = false;
		value = value.replace(/\D/g, "");
		for (var n = value.length - 1; n >= 0; n--) {
			var cDigit = value.charAt(n);
			nDigit = parseInt(cDigit, 10);
			if (bEven) {
				if ((nDigit *= 2) > 9)
					nDigit -= 9;
			}
			nCheck += nDigit;
			bEven = !bEven;
		}
		return (nCheck % 10) == 0;
	}
	function testTicketPremiumAccountId (value) {
		var r = /^([A-Za-z0-9]{11})$|^(\d{16})$/;
		return r.test(value);
	}
	function testBacsWithdrawAccountName (value) {
		return /^([a-zA-Z0-9]){1}([a-zA-Z0-9 ]){0,17}$/.test(value);
	}

	function digitsAndLettersOnly(value) {
		var r = /[^A-Za-z0-9]+/g;
		return !r.test(value);
	}
	

	function testBic(value,params) {
		value = (value || '').trim();
		var len = value.length;
		if(len === 8 || len === 11){
			var r = new RegExp('^[A-Z]{6}[0-9A-Z]{' + (len - 6) + '}$')
			return r.test(value);
		}
		return  false;
	}

	function testWTBic(value,params) {
		value = (value || '').trim();
		var len = value.length;
		if(len === 11){
			var r = new RegExp('[A-Z0-9]{' + len + '}','g');
			return r.test(value);
		}
		return  false;
	}

	function isChecked(value, params) {
		if (params.selector && $(params.selector).is(':checked')) {
			return true;
		}
		return false;
	}

	function testPostFinancePayDirectFlow(value, params) {
		var subObject;
        if (parseFloat(app.lastSelectedAmount) === 0 && $("#" + params.fldName).is(":not(:checked)")) {
            subObject = pubsub.subscribe("app.event.AmountChange", function () {
				app.util.triggerFldValidation(params.fldName, "custom");
				pubsub.unsubscribe(subObject);
            });
            return false;
        }
		subObject && pubsub.unsubscribe(subObject);
        return true;
	}

	function validateNppPayId(value, params) {
		var payIdType = $(params.controlSelector).val();
		if (payIdType === "Email") {
			if (!testEmail(value, params)) {
				params.message = params.invalidEmailMsg;
				return false;
			}
		} else {
			// check other validations
		}
		return true;
	}

	function validatePayToPayId(value, params) {
		var payIdType = $(params.controlSelector).val();
		if (payIdType === "PhoneNumber") {
			var phoneRegex = /^\+61\-[45][0-9]{8}$/;
			if (!phoneRegex.test(value)) {
				return false;
			}
		} else if (payIdType === "Email") {
			if (!testEmail(value, params)) {
				params.message = params.invalidEmailMsg;
				return false;
			}
		} else {
			// check other validations
		}

		return true;
	}

	function validatePixKey(value, params) {
		var pixKeyType = $("#pix_key_type").val();
		var cpfLength = 11;
		var chaveMaxLength = 40;
		var phoneRegex = /^\+55[0-9]{11}$/;

		switch (pixKeyType) {
			case "cpf":
				if (!digitsOnly(value, params)) {
					params.message = params.digitsOnlyMsg;
					return false;
				}

				if (!exactlength(value, {len: cpfLength, message: params.invalidCpfMsg}) || (params.country == "BR" && !testBrazilPersonalId(value))) {
					params.message = params.invalidCpfMsg.replace("{0}", cpfLength);
					return false;
				}

				return true;
			case "phone":
				if (!phoneRegex.test(value)) {
					params.message = params.invalidPhoneMsg;
					return false;
				}

				return true;
			case "email":
				if (!testEmail(value, params)) {
					params.message = params.invalidEmailMsg;
					return false;
				}

				return true;
			case "random":
				if (!maxlength(value, {max: chaveMaxLength, message: params.invalidChaveMsg})) {
					params.message = params.invalidChaveMsg.replace("{0}", chaveMaxLength);
					return false;
				}

				return true;
		}

		return true;
	}

	function maxFractionLength(value, params) {
		var d = value && value.trim().replace(/^0+|0+$/g, '').split('.')[1];
		var l = d && d.length || 0;
		var customRoundingScale = params[app.lastSelectedMethodType || app.current_pm_name];
		if (customRoundingScale && customRoundingScale.hasOwnProperty(params.currencyIso)) {
			params.roundingScale = customRoundingScale[params.currencyIso];
		}
		var isValid = l <= params.roundingScale;
		if (!isValid) {
			params.message = params.message.replace('{0}', params.roundingScale);
		}
		return isValid;
	}


    ////// Other functions

	function _filterOutRestrictedCountries(data) {
		var filteredCountries = data.filter(function (country) {
			return !country.restrictBilling
		});
		return filteredCountries;
	}

	function _getCountries() {
		var def = $.Deferred();
		if (app.countries && app.countries.length > 0) {
			def.resolve(app.countries)
		} else {
			var ajx = $.getJSON('/ppp/getCountries.do' , { ssid: (app.config.ssid || app.rpc.ssid), msid : app.config.msid, locale: app.config.locale });
			ajx.done(function (data) {
				var unrestrictedCountries = _filterOutRestrictedCountries(data);
				app.allCountries = data;
				app.countries = unrestrictedCountries;
				def.resolve(app.countries);
			});
		}
		return def.promise();
	}

	function _getPhoneCodes() {
		var def = $.Deferred();
		if (app.phoneCodes && app.phoneCodes.length > 0) {
			def.resolve(app.phoneCodes)
		} else {
			var ajx = $.getJSON('/ppp/getPhoneCodes.do');
			ajx.done(function (data) {
				data = data.map( function (c) {
					if(c.phoneCode ==='+1US' || c.phoneCode === '+1CA'){
						c.phoneCode = '+1';
					}
					return c;
				});
				app.phoneCodes = data;
				def.resolve(app.phoneCodes);
			});
		}
		return def.promise();
	}

	function remapCurrency(currency) {
		var currencyMap = {
			'eur' : '€', 'usd' : '$', 'gbp' : '£', 'yen' : '¥', 'ils' : '₪', 'inr' : '₹', 'rub' : '₽', 'try' : '₺',
			'cny' : '¥', 'krw' : '₩', 'zar' : 'R', 'brl' : 'R$'
		};
		return currencyMap[currency.toLowerCase()] || currency.toUpperCase();
	}

	function formatAmount(value, roundingScale, thousandsSeparator, useFloatingFraction) {
		var tSeparator = thousandsSeparator || '';
		var round = (roundingScale != undefined) ? roundingScale : 2;
		var v = parseFloat(value);
		if(useFloatingFraction){
			while (round > 0 && v == parseFloat(v.toFixed(round-1))) {
				round--;
			}
		}
		var parts = v.toFixed(round).split('.');
		var intPart = parts[0];
		var decPart = parts[1] || '';
		return intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + tSeparator) + (decPart.length ? '.' : '') + decPart;
	}

	function custom(value, params){
		return params.fn(value, params);
	}
//TODO: <TO_BE_REMOVED>
	var paydotcom = { // todo: change production settings
		keepAliveTimeout: null,
		hasPaydotcomUpo: false,
		preselectPaydotcom: false,
		waitPopupClose: function (popupWnd, closeCallback) {
			window.setTimeout(
				function () {
					if (popupWnd == undefined || popupWnd['closed'] == undefined || popupWnd['closed'] == true) {
						closeCallback();
					} else {
						this.waitPopupClose(popupWnd, closeCallback);
					}
				}.bind(this), 200);
		},
		openPopup: function(url) {
			var popup = '<div id="paydotcom-iframe" style="width: 100%; height: 100%; position: fixed; left: 0; top: 0; display: block; background: rgba(0, 0, 0, .5); z-index: 9999; overflow: auto; -webkit-overflow-scrolling: touch;"><iframe src="' + url + '" style="display: block; width: 100%; height: 100%" /></div>';
			$('body').append(popup);
		},
		closePopup: function() {
			$('#paydotcom-iframe').remove();
			clearTimeout(this.keepAliveTimeout);
			console.log('cancel, remove and clear timeout');
		},
		onSuccess: function() {
		    var self = this;
			this.closePopup();
			this.hasPaydotcomUpo = true;
			$.getJSON('/ppp/clearCacheItem.do', {item : 1, ssid: (app.ssid || app.rpc.ssid)})
				.done(function() {
                    self.preselectPaydotcom = true;
					app.util.paydotcomOnSuccess();
				});
		},
		prePopup: function(locale) {
			var styles = {
				wrapper: 'background: #fff; border-radius: 20px; position: fixed; width: 270px; height: 270px; top: 50%; left: 50%; margin-left: -135px; margin-top: -135px; box-sizing: border-box; box-shadow: 0 0 10px #ccc; padding: 20px 15px; font-family: Arial, sans-serif; z-index: 9999',
				overlay: 'position: fixed; width: 100%; height: 100%; top: 0; left: 0; z-index: 9998',
				p: 'font-size: 17px; font-weight: normal; line-height: 20px; color: #0580C7; text-align: center',
				logo: 'background: url(\'data:image/svg+xml;base64,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\') center center no-repeat; background-size: contain; height: 40px; margin: 0 auto 20px;',
				loader: 'background: url(\'data:image/gif;base64,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\') center center no-repeat; width: 39px; height: 39px; margin: 30px auto 0'
			};
            var text = this.config ? this.config.msg : locale;
			var $panel = $('<div id="paydotcom-overlay" style="' + styles.overlay + '"></div><div id="paydotcom-wrapper" style="' + styles.wrapper + '"><div id="paydotcom-logo" style="' + styles.logo + '"></div><p style="' + styles.p + '">' + text + '</p><div id="paydotcom-loader" style="' + styles.loader + '"></div></div>');
			$('body').append($panel);
		},
		submit: function (data) {
			var url = this.config.url;
			data.params += '&msg=' + encodeURIComponent(this.config.msg);
			if (data.type == 'window') {
				var wnd = window.open('/ppp/paydotcom/blank.jsp?' + data.params, '_paydotcom');
				setTimeout(function() {
					var params = wnd.location.search;
					// wnd.location.href = 'https://dev-mobile.safecharge.com/paycom.html' + params;
					wnd.location.href = url + params;
				}, 4000);
				this.waitPopupClose(wnd, function () {
					this.onSuccess();
				}.bind(this));
			}
			else if (data.type == 'iframe') {
				this.prePopup(data.locale);
				setTimeout(function() {
					// this.openPopup('https://dev-mobile.safecharge.com/paycom.html?' + data.params);
					this.openPopup(url + '?' + data.params);
					$('#paydotcom-overlay, #paydotcom-wrapper').remove();
				}.bind(this), 4000);
			}
			this.keepAlive(data.country);
		},
		keepAlive: function(country) {
			var self = this;
			if (!this.keepAliveTimeout) {
				$.getJSON('/ppp/getCountryStates.do', {countryIso: country, ssid: (app.ssid || app.rpc.ssid)});
			}
			this.keepAliveTimeout = setTimeout(function () {
				$.getJSON('/ppp/getCountryStates.do', {countryIso: country, ssid: (app.ssid || app.rpc.ssid)})
					.done(function () {
						self.keepAlive(country);
					});
			}.bind(this), 540000);
		},
		init : function (url, msg, title) {
			var self = this;
			this.config = {
				url : url || '',
				msg : msg || '',
				title : title || ''
			};

			$(document).on('click', '.paydotcom-trigger', function () {
				var utmMedium = $(this).data('medium');
				if (!self.hasPaydotcomUpo) {
					app.util.paydotcomOnSubmit(utmMedium);
				}
			});

			window.addEventListener("message", function(data) { // todo: add origin filter
				var x = {status: 'none'};
				try{
					x = JSON.parse(data.data);
				} catch(e){}
				if (x.status == 'cancel') {
					utils.paydotcom.closePopup();
				}
				else if (x.status == 'success') {
					utils.paydotcom.onSuccess();
				}

			}, false);

			if (app.checkWithdrawalAllowed) {
				var tpl =  app.util.getLightboxContentTemplate('paydotcom_dialog');
				app.showModalCustomMessage(tpl, 'paydotcom', this.config.title, {}, app.util.paydotcomOnSubmit);
			}
			else {
				pubsub.subscribe('select-pm', function (data) {
					// console.log(data);
					if (data.uniqueId == 'paydotcom' && !self.hasPaydotcomUpo) {
						app.util.paydotcomOnSubmit();
					}
				});
			}
		}
	};

	function paydotcomCardPrefixMask(fld, value) {
		var prefix = function(x) {
			return x.slice(0, 4) + ' ' + x.slice(4, 6);
		};
		var newVal = value || prefix('542703');
		var $fld;
		if ($('input#' + fld, '.PMINFO').length) {
            $fld = $('input#' + fld, '.PMINFO');
		}
		else if ($('input.' + fld, '.PMINFO').length) {
			$fld = $('input.' + fld, '.PMINFO');
		}
		else if ($('input.' + fld, '.payment_options_details').length) {
            $fld = $('input.' + fld, '.payment_options_details');
		}
		var setNewVal = function(val) {
			$fld.val(val);
			$fld.setMask('cc');
			$fld.removeClass('noneLogo').addClass('paydotcomLogo');
		};
		setNewVal(newVal);
		$fld.keydown(function(e) {
			if ($fld.val().length <= 7 && e.keyCode == 8) {
				return false;
			}
		});
		$fld.keyup(function (e) {
			if($(this).val().indexOf(newVal) !== 0) {
				setNewVal(newVal);
			}
		});
	}
//	</TO_BE_REMOVED>

	function handlePassiveEvents() {
		var is_ios = getUserAgentInfo().iOS;
		var opts = (isPassive() ? {
			capture: false,
			passive: false
		} : false);
		var last_ts = Date.now();
		var duration = 40;
		var pointX = 0;

        function isPassive() {
            var _supportsPassiveOption = false;
            try {
                addEventListener("test", null, Object.defineProperty({}, 'passive', {
                    get: function () {
                        _supportsPassiveOption = true;
                    }
                }));
            } catch(e) {}
            return _supportsPassiveOption;
        }
        function isDirectionX(e) {
	        var point  = e.touches ? e.touches[0] : e;
	        var deltaX = point.pageX - pointX;
	        pointX = point.pageX;
	        return (deltaX > 10 ? -1 : deltaX < -10 ? 1 : 0);
        }

		document.addEventListener('touchmove', function (e) {
				var now = Date.now();
				if (now - last_ts < duration) {
					e.preventDefault();
				} else if (!is_ios && $(e.target).parents('.scrollable-x, [data-pms-type="grid"], [data-pms-type="horizontal"]').length) {
					if (isDirectionX(e)) {
						e.preventDefault();
					}
					last_ts = now;
				} else
				if ($(e.target).parents('.scrollable-y, .scrollable, [data-plugin-type="withdrawals"], [data-pms-type]').find('.iScrollLoneScrollbar').length) {
					e.preventDefault();
					last_ts = now;
				}
			},
			opts
		);
	}

	function showToastMessage (payload, timeout) {
		payload = payload || {};
		timeout = timeout || 5000;
		var main_toast_holder = $('#toast-container');
		if(!main_toast_holder.length) { $('body').append( $('<div id="toast-container" class="toast-top" role="alert" style="position: fixed;"></div>')); }
		var $msg_elm = $( _.template('<div class="toast <%- message.type %>" ><div class="toast-message"><%= t( message.msgKey , message.params ) %></div></div>')(payload) );
		$('#toast-container').append($msg_elm).fadeIn();
		setTimeout( function () {
			$msg_elm.fadeOut().delay(500).remove();
		}, timeout);
	}
	function _addFloatingLabelEvents (selector, floatingClass) {
		if (!window.isFloatingLabels) {
			$(document).on('focus setValue', selector, function () {
				var $this = $(this);
				var inputType = $this.attr('type');
				if(inputType !== 'checkbox' && inputType !== 'hidden'&& inputType !== 'radio' ) {
					$this.siblings('label').addClass(floatingClass);
				}
			});
			$(document).on('blur', selector, function () {
				var $this = $(this);
				var inputType = $this.attr('type');
				if(inputType !== 'checkbox' && inputType !== 'hidden' ) {
					if (($this.val() || "").trim() === "") {
						$this.val("");
						$this.siblings('label').removeClass(floatingClass);
					}
				}
			});
			window.isFloatingLabels = true;
		}
	}
	function setLabels(css_input_selector, focused_label_class, preservePlaceholderClassName, preserveAllPlaceholders) {
		setFloatingLabels(css_input_selector, true, focused_label_class, preservePlaceholderClassName, preserveAllPlaceholders);
	}
	function setFloatingLabels(css_input_selector, skipFloating, focused_label_class, preservePlaceholderClassName, preserveAllPlaceholders) {
		var msg = app.msg || app.locale || {};
		var floatingClass = focused_label_class || 'focusedInput';
		var selector = css_input_selector || '.PMINFO input';
		preservePlaceholderClassName = preservePlaceholderClassName || 'preservePlaceholder';
		$(selector).not('[type="hidden"]').each(function(){
			var $this = $(this);
			if(typeof $this.siblings('label')[0] === 'undefined'){
				var placeholder = $this.attr('placeholder') || msg[$this.attr('id')] || $this.attr('id') || $this.attr('name') || '';
				if (placeholder.lastIndexOf('_read_only_text') > -1) {
					placeholder = msg[placeholder.replace('_read_only_text','')] || placeholder.replace('_read_only_text','') || '&nbsp;';
				}
				var labelFor = $this.attr('id') || $this.attr('name') || '';
				$this.before('<label for="' + labelFor +'">'+ placeholder +"</label>");
			}
			if(!preserveAllPlaceholders && !$this.hasClass(preservePlaceholderClassName)) {
				$this.attr('placeholder', '');
			}
			var value = $this.val() || $this.text() || "";
			if(!skipFloating && value.trim() !== ''){
				($this.siblings('label').addClass(floatingClass));
			}
		});
		if (!skipFloating) {
			_addFloatingLabelEvents (selector, floatingClass);
		}
	}

	function handleDomModification (options) {
		if(app._domModificationHandler && typeof app._domModificationHandler === 'function') {
			return app._domModificationHandler;
		}

		var isInIframe = function () {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		}();
		var opt = $.extend({
			jQ_selector : 'body',
			postObj     : {action: 'resizeHeight', payload: "{{current_height}}"},
			parent_url  : "*"
		}, options || {});
		var last_height = 0;
		opt.parent_url  = opt.parent_url || "*";
		var _sendPostMessage = _.throttle(function(){
			var current_height = $(opt.jQ_selector).outerHeight(true);
			if(last_height !== current_height) {
				var msg = JSON.stringify(opt.postObj).replace('"{{current_height}}"', current_height);
				parent.postMessage(msg, opt.parent_url);
				last_height = current_height;
			}
		}, 100, {'trailing': true, 'leading':true});

		function _handleDomModification(ev) {
			if (isInIframe) {
				_sendPostMessage();
			}
		}
		// $(document).on('DOMSubtreeModified', _handleDomModification);
		var observer = new MutationObserver(_handleDomModification);
		observer.observe(document, {
			attributes: true,
			childList: true,
			subtree: true,
			characterData: true,
		});

		app._domModificationHandler = _handleDomModification;
		return _handleDomModification;
	}

	function getUserAgentInfo(){
		var isMobile = (function (a) {
			return /smart-tv|(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
		})(navigator.userAgent || navigator.vendor || window.opera);
		var  ua = navigator.userAgent,
			iPhone = /iphone/i.test(ua),
			chrome = /chrome/i.test(ua),
			android = /android/i.test(ua),
			winPhone = /Windows\sPhone|iemobile/i.test(ua),
			ios = ua.match(/iPhone|iPad|iPod/i);

		if (navigator.userAgentData) {
			// use new hints
			isMobile = navigator.userAgentData.mobile;
			chrome = navigator.userAgentData.brands.some(_containsChrome);
			android = /android/i.test(navigator.userAgentData.platform);
			// navigator.userAgentData.getHighEntropyValues(['architecture', 'bitness', 'brands', 'mobile', 'model', 'platform', 'platformVersion', 'uaFullVersion', 'fullVersionList'])
			// 	.then(function (full_ua){console.log('full_ua:', full_ua);});
			function _containsChrome(item) {
				return ['Chromium', 'Google Chrome', "CriOS", "Chrome on iOS"].includes(item.brand);
			}
		}

		function isOpenedInIOSApp(){
			var openedInIOSApp = false;
			var userAgent = window.navigator.userAgent.toLowerCase();
			var isiOS = /ipad|iphone|ipod/.test(userAgent) && !window.MSStream;
			if (isiOS) {
				var isStandalone = window.navigator.standalone;
				var isSafari = /safari/.test(userAgent);
				if (!isStandalone && !isSafari) {
					openedInIOSApp = true;
				}
			}
			return openedInIOSApp;
		}

		return {
			ua      : ua,
			iPhone  : iPhone,
			chrome  : chrome,
			android : android,
			winPhone: winPhone,
			iOS     : ios,
			isMobile: isMobile,
			isOpenedInIOSApp : isOpenedInIOSApp(),
			useKeyPress : (!isMobile || (isMobile && iPhone && !winPhone))
		}
	}

	function floatingLabels(selector) {
	    var msg = app.msg || app.locale;
	    var floatingClass = 'focusedLabel';

        $(selector).each(function() {
            var $self = $(this);
            if(typeof $self.parents('.row').find('label')[0] === 'undefined') {
                var placeholder = $self.attr('placeholder') || msg[$self.attr('id')] || $self.attr('id') || $self.attr('name') || '';
                var labelFor = $self.attr('id') || $self.attr('name') || '';
                $self.before('<label for="' + labelFor +'">'+ placeholder +"</label>");
            }
            $self.attr('placeholder', '');
            if($self.val() !== '') {
                $self.parents('.row').find('label').addClass(floatingClass);
            }
        });
		_addFloatingLabelEvents (selector, floatingClass);
    }

    function triggerNativeResizeEvent() {
        if (document.createEvent) {
            var ev = document.createEvent('Event');
            ev.initEvent('resize', true, true);
            window.dispatchEvent(ev);
        }
        else {
            var el = document.documentElement;
            var ev = document.createEventObject();
            el.fireEvent("onresize", ev);
        }
	}

    function oneRowExpDateHelper($expDate) {
        var selectedText = '';
        var getSelectionText = function() {
            if (window.getSelection) {
                if (document.activeElement &&
                    (document.activeElement.tagName.toLowerCase() == "textarea" ||
                        document.activeElement.tagName.toLowerCase() == "input")) {
                    var text = document.activeElement.value;
                    selectedText = text.substring(document.activeElement.selectionStart,
                        document.activeElement.selectionEnd);
                }
                else {
                    var selRange = window.getSelection();
                    selectedText = selRange.toString();
                }
            }
            else {
                if (document.selection.createRange) {
                    var range = document.selection.createRange();
                    selectedText = range.text;
                }
            }
            return selectedText;
        };

        $expDate.on('blur select', getSelectionText);
        $expDate.on('keyup', function(e) {
            if ($(this).val().length == 2 && e.keyCode != 8) {
                $(this).val($(this).val() + '/');
            }
        });
        $expDate.on('keydown', function(e) {
            var isNumber = (e.keyCode >= 50 && e.keyCode <= 57) || (e.keyCode >= 98 && e.keyCode <= 105);
            if (isNumber  && (!$(this).val().length || selectedText == $(this).val())) {
                $(this).val('0');
            }
        });
    }

    function isPMBlocked(data) {
        return (data && data.blockers && !_.isEmpty(data.blockers)) ? data.blockers : {};
    }

    function renderBlockedPMReasons(data) {
		var blockers = isPMBlocked(data);
		var $el = $('#blocked_method_messages-template');
		var template = '<ul id="blocked_method_messages_list">' +
			'<% _.each(data, function(val, key) {' +
			'if(key == "metaDataBlocker" ){ var info = val.contactInfo; %>' +
			'<li class="metaDataBlocker">' +
				'<div><%- t(val.message1)%></div><div><%- t(val.message2)%></div>' +
				'<% if(info && !_.isEmpty(info)){ %>' +
					'<div class="contact_info"><p><%- t("contact_info")%></p>' +
						'<% _.each(["contactName", "contactWebsite", "contactEmail", "contactNumber"], function(v, k) {' +
						'if(info[v]){%><div><span><%- t(v,[info[v]])%></span></div>' +
						'<%}})%>' +
					'</div>' +
				'<%}%>' +
			'</li>' +
			'<% }else{ %>' +
			'<li class="<%= key %>_blocker"><%= val %></li>' +
			'<% }}); %>' +
			'</ul>';
		if (!_.isEmpty(blockers)) {
			var tpl = ($el.length) ? _.template($el.text()) : _.template(template);
			var html =  tpl({
				data: blockers
			});
			if ($('#blocked_method_messages').length) {
				$('#blocked_method_messages').html(html);
			} else {
				$('.PMINFO').prepend('<div id="blocked_method_messages">' + html + '</div>');
			}
		} else {
			$('#blocked_method_messages').empty();
		}
	}
		
	function getCancelWdrPostMessageData(payloadMessage, wdrResponseFromSrv, wdListRequests, upoList) {
		var obj = {
			"payload" : payloadMessage,
			"amount" : wdrResponseFromSrv.wdRequest.requestedAmount,
			"currency" : wdrResponseFromSrv.wdRequest.requestedCurrency
		};
		
		var wdrRequest = _.find(wdListRequests, {"wd_requestId": wdrResponseFromSrv.wdRequest.wd_requestId});

		var item = (wdrRequest && (wdrRequest.orders.length && wdrRequest.orders[0] || wdrRequest.params)) || {};

		if (item.poName) {
				obj['payment_method'] = item.poName;
		}

		if (item.upoId) {
				var upoData = upoList[item.upoId];

				if (upoData && upoData.hasOwnProperty('isLastUsedAccount')) {
					obj['method_status'] = upoData.isLastUsedAccount ? 'Active' : 'Inactive';
				}

				if (upoData && upoData.verificationStatus) {
					obj['verification_status'] =  upoData.verificationStatus;
				}
		}

		return obj;
	}

	function remapCardSupportedCurrencies (obj) {
		var retObj = {};
		if ( !_.isEmpty(obj)) {
			_.each(obj, function(arr, prop) {
				if (!_.isEmpty(arr) && _.isArray(arr) && arr.length) {
					retObj[prop] = {};
					for (var idx = 0; idx < arr.length; idx++) {
						retObj[prop][arr[idx].toUpperCase()] = 1;
					}
				}
			});
		}
		return retObj;
	}

	function sendPostMessageFromAttr() {
        var key = $(this).data('msg-key');
        var value = $(this).data('msg-val');
        var msg = {};
        if (key && value) {
            msg[key] = value;
        }
        else if (key) {
            msg = key;
        }
        if (!_.isEmpty(msg)) {
            app.util.sendPostMessage(msg);
        }
	}
	
	function sendRefreshPagePostMessages () {
        app.util.sendPostMessage('refreshPage');
        app.util.sendPostMessage({
            'action': 'refreshPage',
            'payload': {}
        });
    }

	function showVersionOnAltVTwice() {
		var lastTime;
		$(document).on('keyup', function (e) {
			var KeyCodeV = 86;
			if (e.altKey && e.keyCode === KeyCodeV) {
				var now = (new Date()).getTime();
				var showVersion = (now - lastTime) < 300;
				lastTime = now;
				if (showVersion) {
					alert(document.getElementsByTagName('head')[0].firstChild.nextSibling.textContent.trim());
				}
			}
		});
	}

	function showQROnAltQTwice() {
		var displayQRCode = function () {
			var lightBoxElm = $("#lightbox");
			lightBoxElm.removeClass().addClass('success');
			$('.lightbox-header', lightBoxElm).html('<h2>URL QRCode</h2><a class="modal_close" href="#"></a>');
			$('.lightbox-content', lightBoxElm).html('<div id="qrcode" style="width:256px;margin:0 auto;"></div>');
			$('.lightbox-content', lightBoxElm).css('background', 'white');
			app.modalLink.trigger('click');
			var onQrCodeAvailable = function (qrCodeInst) {
				$.ajax({
					url         : 'https://www.googleapis.com/urlshortener/v1/url?key=AIzaSyBCjT46Qxaeyqv5hpEpPazvODouSpEOjq8',
					type        : 'POST',
					contentType : 'application/json; charset=utf-8',
					data        : '{ longUrl: "' + window.location.href + '"}',
					dataType    : 'json',
					success     : function (resp) {
						qrCodeInst.makeCode(resp.id);
					}
				});
			};
			try {
				onQrCodeAvailable(new QRCode('qrcode'));
			} catch (e) {
				$.getScript('resources/js/qrcode.min.js', function () {
					onQrCodeAvailable(new QRCode('qrcode'));
				});
			}
		};
		var lastTime;
		$(document).on('keyup', function (e) {
			var KeyCodeQ = 81;
			if (e.altKey && e.keyCode === KeyCodeQ) {
				var now = (new Date()).getTime();
				var showQRCode = (now - lastTime) < 300;
				lastTime = now;
				if (showQRCode)
					displayQRCode();
			}
		});
	}

	function startSessionTimer() {
		var pollIntervalInSeconds = app.config.session.pollInterval / 1000;

		app.config.session.secondsLeft -= pollIntervalInSeconds;

		if (app.config.session.secondsLeft <= pollIntervalInSeconds) {
			app.config.session.isSessionExpired = true;
			app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
		} else {
			app.config.session.timeoutId = setTimeout(startSessionTimer, app.config.session.pollInterval);
		}
	}

	function restartSessionTimer() {
		clearTimeout(app.config.session.timeoutId);
		app.config.session.secondsLeft = app.config.session.expirationMinutes;
		startSessionTimer();
	}

	function getInltFormatedCurrency(currency, amount) { 
		var locale;
		if (app.rpc) {
			locale = app.rpc.merchantLocale;
		} else {
			locale = app.config.locale;
		}

		return new Intl.NumberFormat(locale.replace('_', '-'), 
						{ style: 'currency', currency: currency, minimumFractionDigits:0,maximumFractionDigits:2 } )
							.format(amount);
	}

	function createColorObj(c) {
		var color = {};
		var rgba = [];
		if (c.startsWith('rgb')) {
			rgba = c.replace('rgb(', '').replace('rgba(', '').replace(')', '').replace(/ /g, '').split(',').map(function (v) {
				return parseFloat(v);
			});
		} else if (c.startsWith('#') || c.length === 6 || c.length === 3) {
			var hex = c.replace('#', '');
			if (hex.length === 3){
				hex = '' + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
			}
			rgba = [parseInt(hex.substring(0, 2), 16), parseInt(hex.substring(2, 4), 16), parseInt(hex.substring(4, 6), 16)];
		}
		if (rgba.length === 3) {
			rgba.push(1);
		}
		color.rgba = rgba;
		color.alpha = rgba[3] === 0 ? 0 : rgba[3] || 1;
		color.luminance = getRelativeLuminance(color.rgba);
		return color;
	}

	function getRelativeLuminance(rgb_arr) {
		var rgba = rgb_arr.slice();
		for (var i = 0; i < 3; i++) {
			var x = rgb_arr[i];
			x /= 255;
			x = x < .03928 ? x / 12.92 : Math.pow((x + .055) / 1.055, 2.4);
			rgba[i] = x;
		}
		return 0.2126 * rgba[0] + 0.7152 * rgba[1] + 0.0722 * rgba[2];
	}

	function overlayOn(base_color, color) {
		var overlaid = $.extend(true, {}, base_color);
		var alpha = base_color.alpha;
		if (alpha >= 1) {
			return overlaid;
		}
		for (var i = 0; i < 3; i++) {
			overlaid.rgba[i] = overlaid.rgba[i] * alpha + color.rgba[i] * color.rgba[3] * (1 - alpha);
		}
		overlaid.rgba[3] = alpha + color.rgba[3] * (1 - alpha);
		return overlaid;
	}

	function getContrast(baseColorObj, colorObj) { // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
		function floor(number, decimals) {
			decimals = +decimals || 0;
			var multiplier = Math.pow(10, decimals);
			return Math.floor(number * multiplier) / multiplier;
		}

		//var alpha = baseColorObj.alpha;
		//if (alpha < 1) {}
		if (colorObj.alpha < 1) {
			colorObj = overlayOn(colorObj, baseColorObj);
		}
		var l1 = baseColorObj.luminance + .05,
			l2 = colorObj.luminance + .05,
			ratio = l1 / l2;
		if (l2 > l1) {
			ratio = 1 / ratio;
		}
		ratio = floor(ratio, 2);
		return {
			ratio : ratio,
			error : 0,
			min   : ratio,
			max   : ratio
		};
	}

	function getColorSettings(bgColor) {
		var apple_black  = {alpha: 1, luminance: 0, rgba: [0, 0, 0, 1]};
		var apple_white  = {alpha: 1, luminance: 1, rgba: [255, 255, 255, 1]};
		var vco_neutral  = {alpha: 1, luminance: 0.8549926081242338, rgba: [238, 238, 238, 1]};
		var vco_standard = {alpha: 1, luminance: 0.02391839461454067, rgba: [26, 31, 113, 1]};
		var venmo_blue   = {alpha: 1, luminance: 0.2597616702652387, rgba: [0, 140, 255, 1]};
		var venmo_white  = {alpha: 1, luminance: 1, rgba: [255, 255, 255, 1]};
		var bg = createColorObj(bgColor);
		bg.contrast = {
			to_apple_black  : getContrast(apple_black, bg).ratio,
			to_apple_white  : getContrast(apple_white, bg).ratio,
			to_vco_neutral  : getContrast(vco_neutral, bg).ratio,
			to_vco_standard : getContrast(vco_standard, bg).ratio,
			to_venmo_blue   : getContrast(venmo_blue, bg).ratio,
			to_venmo_white  : getContrast(venmo_white, bg).ratio
		};
		bg.apple_btn_style  = (bg.contrast.to_apple_white > bg.contrast.to_apple_black) ? 'white' : 'black';
		bg.google_btn_style = (bg.contrast.to_apple_white > bg.contrast.to_apple_black) ? 'white' : 'black';
		bg.vco_btn_style    = (bg.contrast.to_vco_neutral > bg.contrast.to_vco_standard) ? 'neutral' : 'standard';
		bg.venmo_btn_style  = (bg.contrast.to_venmo_white > bg.contrast.to_venmo_blue) ? 'white' : 'blue';
		return bg;
	}

	/**
	 * VisaCheckout provides custom <img> per UPO
	 * witch we use through custom CSS classes
	 *
	 * @returns {string} class name suffix
	 */
	function getCustomImgClassNameSuffix(metadata, upoId) {
		var supportedImageMimeType = {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1,
			"url" 			: 1 // PWMB case >> resourceTypeUrl
		};
		var suffix = '';
		if (upoId && metadata && metadata.imgContent && metadata.imgMimeType && supportedImageMimeType[metadata.imgMimeType]) {
			suffix = '_' + upoId + '_modified';
		}
		return suffix;
	}

	function storeCardCredentialsHandler(scc, pm_name) {
		var paymentMethods = scc.supportedPMs || [];
		var $storeCardWrapper = $('#store_card_wrapper');
		var $container = $storeCardWrapper.length ? $storeCardWrapper : $('.PMINFO');
		if (scc && scc.isActive && !scc.useLightbox && scc.flow !== 'DISABLE_FEATURE' && _.indexOf(paymentMethods, pm_name) > -1) {
			if (scc.flow === 'SHOW_TEXT_ONLY') {
				var $paymentMethodWarningContainer = $(_.template('<div id="store-cc-details" class="scc store-cc-details"> <%= t(message) %> </div>')({
					message : 'save_pm_details_text'
				}));
				if ($storeCardWrapper.length) {
					$container.append($paymentMethodWarningContainer);
				} else {
					$container.prepend($paymentMethodWarningContainer);
				}
			} else {
				var checked = (scc.flow === 'SHOW_WITH_YES') ? 'checked' : '';
				var tplTxt = '<div class="row scc storeCardCredentials toggleRow">' +
					'<input type="checkbox" id="sccToggle" name="allowSaveCardUpo" class="toggle_checkbox" <%- checked %> />' +
					'<label for="sccToggle">' +
					'<span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span>' +
					'<%= t("save_pm_details_toggle_text")%></label></div>';
				var html = _.template(tplTxt)({checked: checked});
				$container.append($(html));
			}
		}
	}

	function showStoreCardTerms(e) {
		(e && e.preventDefault());
		var language = app.config.locale ? app.config.locale : app.config.merchantLocale;
		var scc = app.config.storeCard || {};
		var url = scc.merchantAdditionalInfoURL;

		if (url) {
			url = utils.addQueryStringParams(url, {
				"merchantName" : app.config.merchantDescriptor || 'the company',
				"language"     : language.split('_')[0]
			});
			if (scc.openTermsInNewWindow) {
				var win = window.open(url, '_blank');
				win.focus();
			} else {
				var html = _.template('<div class="scc-header"><%= t(title)%><%if(isStandalone){%><span class="modal_close">&#215;</span><%}%></div>' +
					'<div class="lbx_scc_terms"><iframe src="<%= url %>" width="100%" height="100%" scrolling="auto"/></div><%if(openTermsInCustomLightbox){%><div class="scc_popup_footer"><button class="scc_popup_footer-btn"><%- t("lightbox_success_button") %></button></div><%}%>')({
					isStandalone : !scc.useLightbox,
					url          : url,
					title        : 'scc_lightbox_title',
					openTermsInCustomLightbox	 : scc.openTermsInCustomLightbox
				});
				if (scc.useLightbox) {
					$('#confirmation_footer').html(html);
				} else {
					var lightBoxElm = $("#lightbox");
					lightBoxElm.removeClass();
					
					if(scc.openTermsInCustomLightbox) {
						lightBoxElm.addClass('lbx_scc_popup');
					} else {
						lightBoxElm.addClass('lbx_scc_terms');
					}

					$('.lightbox-header', lightBoxElm).html('<h2></h2>');
					$('.lightbox-content', lightBoxElm).html(html);
					app.modalLink.trigger('click');
					pubsub.publish('lightbox.opened', [{type: 'scc_terms', isWs: false}]);
				}
				$(window).trigger('resize');
			}
		}
	}

	function addQueryStringParams(url, params) {
		url = (url || '').trim();
		var startSymbol = '';
		var paramArray = [];
		var lastQuestionMarkInd = url.lastIndexOf('?');
		if (lastQuestionMarkInd < 0) {
			startSymbol = '?';
		} else if (lastQuestionMarkInd < (url.length - 1)) {
			startSymbol = '&';
		}
		$.each(params, function (key, value) {
			paramArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
		});
		return url + startSymbol + paramArray.join('&');
	}

	var getCardAsyncChecker = (function () {
		return function (country, ssid, msid, baseUrl) {
			var cash = {count : 0};
			var asyncChecking = 0;
			var _notifyArr = [];
			var _notifyObj = {};
			var _inProgress = {};
			var _lastResponse;

			function _reset() {
				cash = {count : 0};
				asyncChecking = 0;
				_notifyArr = [];
				_notifyObj = {};
				_lastResponse = false;
			}

			function _isComplete() {
				return (asyncChecking < 1);
			}

			function _onComplete(fn, hashKey) {
				if (_.isFunction(fn)) {
					if (asyncChecking < 1) {
						fn(_.clone(_lastResponse));
					} else if (hashKey) {
						_notifyObj[hashKey] = fn;
					} else {
						_notifyArr.push(fn);
					}
				}
			}

			function _getCardErrorMsg(v) {
				v = (v || '').replace(/[^\d]/g, '');
				if (cash[v]) {
					return !cash[v].isCardAllowed && cash[v].errorMessage && {
						text : cash[v].errorMessage,
						code : cash[v].errorField,      // "cardType", "cardProduct", "issuerCountry", "userCountry"
						val  : (cash[v].errorField === "userCountry" ? country : cash[v][cash[v].errorField] || '')
					};
				}
				return false;
			}

			function _getCardInfo(v) {
				v = (v || '').replace(/[^\d]/g, '');
				if (cash[v]) {
					return $.extend(true, {}, cash[v]);
				}
				return false;
			}

			function _cardDetails(value, cb) {
				var handler = _.isFunction(cb) ? cb : _.identity;
				var v = (value || '').replace(/[^\d]/g, '');
				if (!v.length || !cb) {
					return;
				}
				asyncChecking += 1;
				if (cash[v]) {
					// make it async for consistency
					setTimeout(function () {
						asyncChecking -= 1;
						handler(_.clone(cash[v]), value);
					}, 0);
				} else if (_inProgress[v]) {
					asyncChecking -= 1;
					_.isFunction(cb) && _onComplete(cb);
				} else {
					_inProgress[v] = 1;
					var url = baseUrl + "?ssid=" + encodeURIComponent(ssid);
					var pmName = app.lastSelectedMethodType || app.current_pm_name;
					var data_to_send = {
						"msid"       : msid,
						"ssid"       : ssid,
						"cardNumber" : v,
						"forceCardRecognition": (pmName === 'bancontact_cc_card')
					};
					$.ajax({
						type        : "POST",
						url         : url,
						data        : JSON.stringify(data_to_send),
						contentType : 'application/json',
						dataType    : 'json',
						success     : function (r) {
							_onResponseOrTimeout(r, v, value, handler);
						},
						timeout     : 10000
					}).fail(function () {
						_onResponseOrTimeout(null, v, value, handler);
					});
				}
			}

			function _notifyAll(r, v, value) {
				if (asyncChecking < 1) {
					var f;
					while ((f = _notifyArr.shift()) !== undefined) {
						f(r, value);
					}
					_.each(_notifyObj, function (fn, key) {
						fn(r, value);
						delete _notifyObj[key];
					});
				}
			}

			function _onResponseOrTimeout(r, v, value, handler) {
				_lastResponse = null;
				asyncChecking -= 1;
				cash.count++;
				if (r) {
					_lastResponse = _.clone(r);
					cash[v] = _.clone(r);
					handler(r, value);
				} else {
					handler({"isCardAllowed" : true, req_timeout : true}, value);
				}
				_inProgress[v] = false;
				_notifyAll(r, v, value);
			}

			return {
				reset           : _reset,
				isComplete      : _isComplete,
				onComplete      : _onComplete,
				getCardErrorMsg : _getCardErrorMsg,
				getCardInfo		: _getCardInfo,
				cardDetails     : _cardDetails
			};
		}
	})();

	var getIntlFormatter = (function (IntlNumberFormat, simpleNumberFormatter) {
		var TYPE = {DECIMAL : "Decimal", CURRENCY : 'Currency'};
		var defaults = {
			enableCaching           : false,
			useFixedFraction        : false,
			defaultThousandsSeparator : ' ',
			simpleDecimalFormatter  : function (amount, currency, precision, toFixed) {
				var useFloatingFraction = (toFixed !== undefined) ? !toFixed : !this.useFixedFraction;
				return simpleNumberFormatter(amount, precision, this.defaultThousandsSeparator, useFloatingFraction);
			},
			simpleCurrencyFormatter : function (amount, currency, precision, toFixed) {
				var useFloatingFraction = (toFixed !== undefined) ? !toFixed : !this.useFixedFraction;
				return simpleNumberFormatter(amount, precision, this.defaultThousandsSeparator, useFloatingFraction) + (currency ? ' ' + currency : '');
			},
			onBeforeDecimalFormat   : false, // false | function onBeforeDecimalFormat  (amount, currency, precision) { return /* formatted string | false */; },
			onBeforeCurrencyFormat  : false, // false | function onBeforeCurrencyFormat (amount, currency, precision) { return /* formatted string | false */; },
			onAfterDecimalFormat    : false, // false | function onAfterDecimalFormat   (formattedStr, currency, precision) { return formattedStr; },
			onAfterCurrencyFormat   : false, // false | function onAfterCurrencyFormat  (formattedStr, currency, precision) { return formattedStr; },
			rounding                : {
				CLP: 0, DJF: 0, ISK: 0, JPY: 0, KRW: 0, PYG: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, YEN: 0, BYR: 0, GNF: 0, MMK: 0, RWF: 0, XPF: 0, IDR: 0, COP: 0,
				BHD: 3, IQD: 3, JOD: 3, KWD: 3, OMR: 3, TND: 3,
			}
		};

		return function (locale, baseCurrency, options) {
			baseCurrency = baseCurrency || 'default';
			var cfg = $.extend(true, defaults, options || {});

			var localesArr = (locale ? [locale.replace('_', '-'), 'en-US'] : ['en-US']);
			var formatters = {
				Decimal  : {},
				Currency : {}
			};
			var last_used_formatter = {};
			var nFormat = typeof IntlNumberFormat == 'function' && IntlNumberFormat || _intlFallback;

			/** @param locale - is only to align the parameters with those of the Intl.NumberFormat */
			function _intlFallback(locale, opt) {
				var currency = opt && opt.currency,
					precision = 2;
				if (currency && cfg.rounding[currency] !== undefined) {
					precision = cfg.rounding[currency];
				} else if (!currency && cfg.rounding[baseCurrency] !== undefined) {
					precision = cfg.rounding[baseCurrency];
				}
				return {
					format          : function (amount) {
						amount = amount || 0;
						if (currency) {
							return cfg.simpleCurrencyFormatter(amount, currency, precision);
						}
						return cfg.simpleDecimalFormatter(amount, currency, precision);
					},
					resolvedOptions : function () {
						return {isBaseFormatter : true};
					}
				};
			}

			function _getFormatOptions(type, currencyISO, precision, toFixed) {
				var round = (precision != undefined) ? precision : (cfg.rounding[currencyISO] !== undefined ? cfg.rounding[currencyISO] : 2);
				var minFractionDigits = (toFixed != undefined) ? (toFixed ? round : 0) : (cfg.useFixedFraction ? round : 0);
				var o = {
					style                 : type.toLowerCase(),
					minimumFractionDigits : minFractionDigits,
					maximumFractionDigits : round
				};
				if (type === TYPE.CURRENCY) {
					o.currencyDisplay = 'symbol';
					o.currency = currencyISO;
				}
				return o;
			}

			function _getFormatter(type, currency, precision, toFixed) {
				currency = currency != undefined ? currency : baseCurrency;
				var hash = (currency + '_' + precision + '_' + toFixed);
				if (cfg.enableCaching) {
					if (!formatters[type][currency]) {
						formatters[type][currency] = {};
					}
					if (!formatters[type][currency][hash]) {
						formatters[type][currency][hash] = new nFormat(localesArr, _getFormatOptions(type, currency, precision, toFixed));
					}
					return formatters[type][currency][hash];
				}
				return new nFormat(localesArr, _getFormatOptions(type, currency, precision, toFixed));
			}

			function _format(type, amount, currency, precision, toFixed) {
				var onBefore = cfg['onBefore' + type + 'Format'];
				var onAfter = cfg['onAfter' + type + 'Format'];
				var result = onBefore && onBefore(amount, currency, precision, toFixed);
				if (result) {
					last_used_formatter[type] = "custom onBefore" + type + "Format";
				} else {
					var f = _getFormatter(type, currency, precision, toFixed);
					last_used_formatter[type] = f;
					result = f.format(amount || 0);
				}
				if (onAfter) {
					var tmpR = result;
					result = onAfter(result, currency, precision, toFixed);
					if (tmpR !== result) {
						last_used_formatter[type] = "custom onAfter" + type + "Format";
					}
				}
				return result;
			}

			function _formatDecimal(amount, currency, precision, toFixed) {
				return _format(TYPE.DECIMAL, amount, currency, precision, toFixed);
			}

			function _formatCurrency(amount, currency, precision, toFixed) {
				return _format(TYPE.CURRENCY, amount, currency, precision, toFixed);
			}

			function _getCurrencySymbol(currency) {
				return _format(TYPE.CURRENCY, 0, currency, 0, true).replace('0', '').trim();
			}

			function _isRightPositionedCurrency(currency) {
				return _format(TYPE.CURRENCY, 0, currency, 0, true).startsWith('0');
			}

			function _getFormattersOptions(type, currency) {
				var ret = {
					formattersType : type,
					lastUsed       : (_.isObject(last_used_formatter[type])
						&& last_used_formatter[type].resolvedOptions
						&& last_used_formatter[type].resolvedOptions()
						|| last_used_formatter[type])
				};
				if (currency) {
					ret[currency] = formatters[type][currency] && {};
					_.each(formatters[type][currency], function (v, k) {
						ret[currency][k] = v.resolvedOptions && v.resolvedOptions();
					});
				} else if (cfg.enableCaching) {
					_.each(formatters[type], function (o, c) {
						ret[c] = {};
						_.each(formatters[type][c], function (v, k) {
							ret[c][k] = v.resolvedOptions && v.resolvedOptions();
						});
					});
				}
				return ret;
			}

			return {
				formatCurrency             : _formatCurrency,
				formatDecimal              : _formatDecimal,
				getCurrencySymbol          : _getCurrencySymbol,
				isRightPositionedCurrency  : _isRightPositionedCurrency,
				getDecimalResolvedOptions  : function (currency) {
					return _getFormattersOptions(TYPE.DECIMAL, currency)
				},
				getCurrencyResolvedOptions : function (currency) {
					return _getFormattersOptions(TYPE.CURRENCY, currency)
				},
				showConfig                 : function () {
					return JSON.stringify(cfg);
				}
			};
		};
	})(Intl && Intl.NumberFormat, formatAmount);

	function onTabPressFixIScrollV(e) {
		if (e.keyCode === 9 && app.scroller) {
			var aElm = document.activeElement;
			var p = $(this).parent();
			if (aElm && p.data('plugin') === "scrollable") {
				var ah = $(aElm).outerHeight(true);
				var oft = -(p.height() - ah);
				/** fix iScroll Vertical behaviour: */
				app.scroller.scrollToElement(aElm, 300, 0, (oft > 10 ? 0 : oft));
			}
		}
	}

	function generateFieldValidationRules(fldObj) {
		var checks = {},
			type = (fldObj.inputType || '').toUpperCase();
		if (type === 'CHECKBOX') {
			var isExeption = {mwd_id1: 1, mwd_id2: 1, mwd_id3: 1, mwd_id4: 1, mwd_id5: 1, mwd_field1: 1, mwd_field2: 1, mwd_field3: 1, mwd_field4: 1, mwd_field5: 1, mwd_field6: 1, mwd_field7: 1, mwd_field8: 1, mwd_field9: 1, mwd_field10: 1};
			checks.isChecked = {
				selector: ('#' + fldObj.name),
				msgKey: (isExeption[fldObj.name] ? 'invalid_' + fldObj.name : 'unconfirmed_agreement')
			};
		} else {
			checks.notEmpty = {msgKey: "required_field"};
		}

		if (fldObj.regex && fldObj.regex.trim()) {
			var regex;
			try {
				regex = new RegExp(fldObj.regex.trim());
			} catch (e) {
			}
			if (regex) {
				checks.testRegex = {
					regex: regex,
					msgKey: fldObj.errorMsg || 'invalid_' + fldObj.name
				};
			}
		} else {
			if (fldObj.minlength) {
				checks.minlength = {min: fldObj.minlength, msgKey: 'minlength'};
			}
			if (fldObj.maxlength) {
				checks.maxlength = {max: fldObj.maxlength, msgKey: 'maxlength'};
			}
			if (type === 'EMAIL') {
				checks.testEmail = {msgKey: 'invalid_email'};
			} else if (type === 'TEL') {
				checks.testPhonenumber = {msgKey: 'invalid_phone_number'};
			}
		}
		return checks;
	}

	/** =============== <ExtraDetails> =============== **/
	function getPmExtraDetails(pmName, url, isWD, data) {
		var def = $.Deferred();
		if (url) {
			var dataToSend = $.extend(true, {}, data, {
				ssid: app.config.ssid,
				msid: (isWD ? app.config.merchant_site_id : app.config.msid),
				workflowType: (isWD ? 'WITHDRAW' : 'DEPOSIT'),
				paymentMethod: pmName
			});

			$.ajax({
				type: "POST",
				url: utils.addQueryStringParams(url,{"ssid":  app.config.ssid}),
				data: JSON.stringify(dataToSend),
				contentType: 'application/json',
				dataType: 'json',
				success: function (extra_data) {
					var uniqueIdAsNumber = parseInt(extra_data && extra_data.uniqueId);
					var isUpo = !isNaN(uniqueIdAsNumber);
					if (isUpo) {
						/* ensure upo uniqueId is of type Number */
						extra_data.uniqueId = uniqueIdAsNumber;
					}
					def.resolve(extra_data);
				},
				timeout: 10000
			}).fail(function () {
				def.resolve(false);
			});
		} else {
			def.resolve(false);
		}
		return def.promise();
	}

	function formatExtraDetails(extra_data) {
		var uniqueIdAsNumber = parseInt(extra_data && extra_data.uniqueId);
		var isUpo = !isNaN(uniqueIdAsNumber);
		if (isUpo) {
			/* ensure upo uniqueId is of type Number */
			extra_data.uniqueId = uniqueIdAsNumber;
		}
		_.each(extra_data && extra_data.paymentDetails, function (item, key) {
			if (_.isObject(item)) {
				item.name = key;
				item.value = item.value || '';
				item.inputType = (item.inputType || 'text').toLowerCase();
			}
		});
		return extra_data;
	}

	function getExtraDetailsFieldTemplate(fld_name, inputType) {
		var defaultTemplate = '<div class="row <%-name%> <%- disabled %>"><div class="pmf-icon"></div><label for="<%-name%>" class="<%if(value || inputType=="date" ){%>focusedInput<%}%>"><%-t(label)%></label>' +
			'<input autocomplete="off" type="<%-inputType%>" <%if(!skipMaxlengthAttr){%>maxlength="<%-maxlength%>"<%}%> <%_.each(normalizedData[name].dataAttr, function(v, k){%> data-<%-k%>="<%- v%>" <%})%> ' +
			'id="<%-name%>" class="<%-name%>" name="<%-name%>" value="<%-value%>" <%- disabled %> placeholder="<%-t(label)%>" title="<%-t(label)%>">' +
			'<div id="<%-name%>_validation" class="validation_image"></div></div>';

		var custom_tpl = $('#extra_fld_' + fld_name);
		var fld_type = (inputType || 'DEFAULT').toUpperCase();

		var tpl = {
			sightline_enrollButton: '' +
				'<% var buttonLabel = label; ' +
				'var additionalClasses = ""; ' +
				'if (app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance) {' +
					'if (!app.util.isUpo(app.lastSelectedMethodId) && normalizedData && normalizedData.sightline_balanceButton && normalizedData.sightline_balanceButton.value === "") {' +
						'buttonLabel = t("playplus_enroll");' +
						'additionalClasses += " enroll-btn";' +
					'} else {' +
						'buttonLabel = t("playplus_fund");' +
					'}' +
				'} %>' +
				'<div class="row <%-name%> <%- additionalClasses %>">' +
					'<button type="button" role="button" id="<%-name%>" class="btn generic_btn <%-name%>" onclick="app.util.getOnRegisterClickHandler(app.lastSelectedMethodType || app.current_pm_name)();" >' +
						' <%- buttonLabel %> ' +
					'</button>' +
					'<% if (!app.config.isOpenAmount) { %><div id="<%-name%>_validation" class="validation_image"></div><% } %>' +
				'</div>',
			sightline_balanceButton: '' +
				'<% var isUpo = app.util.isUpo(app.lastSelectedMethodId);' +
				'if (isUpo || !app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance || !normalizedData || !normalizedData.sightline_balanceButton || normalizedData.sightline_balanceButton.value !== "") { %>' +
					'<div class="row <%-name%>">' +
					'<% var btn =\'<button type="button" role="button" class="btn_display_balance" onclick="\' +(isUpo ? "app.util.getUpmExtraDetails" : "app.util.getPmExtraDetails") +\'(app.lastSelectedMethodId, {});" ><i class="eye"></i>\' +  t("display") + \'</button>\';' +
					'var balance_info = value!=="" ? c.formatCurrency(value, (app.currency || app.config.wd_currency), null, true) : btn; %>' +
					'<div class="info"><%= t("sightline_balance_info", [balance_info])%></div></div>' +
				'<% } %>',
			sightline_ssn: '' +
				'<% if (app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance && !app.util.isUpo(app.lastSelectedMethodId) && normalizedData && normalizedData.sightline_balanceButton && normalizedData.sightline_balanceButton.value === "") { %>' +
					' ' +
				'<% } else { %>' +
					defaultTemplate +
				'<% } %>',
			globalpay_balance: '<div class="row <%-name%>"> <% var balance = c.formatCurrency(value, (app.currency || app.config.wd_currency)); var user = app.user.firstName + " " + app.user.lastName; %>' +
				'<div class="greeting"><%= t("greeting", [user])%></div> <div class="info"><%= t("globalpay_balance_info", [balance])%></div></div>'
			,
			globalpay_addAccountButton: '<div class="row <%-name%>"> ' +
				'<button type="button" role="button" id="<%-name%>" class="btn <%-name%>" onclick="app.util.onAddAccountClicked(this);" data-action="<%-action%>" >' +
				' <%- label%>  </button></div>',
			SELECT: '<% var opt = {lbl_txt: label, lbl_class:"focusedInput", val: value, data: dropDownOptions, disabled:(disabled?"disabled":"")}; %>' +
				'<div class="row <%-name%> default_select_wrap"><div class="pmf-icon <%-name%>"></div>' +
				'<% var lbl_txt = t(opt.lbl_txt || name); %><label class="<%-(opt.lbl_class||"")%>" for="<%-name%>"><%= lbl_txt%></label><select id="<%-name%>" class="<%-name%>" name="<%-name%>" placeholder="<%= lbl_txt%>" title="<%= lbl_txt%>"  data-plugin="cSelect" <%- (opt.disabled || "")%> >\n' +
				'<% var val = (opt.val || value), data = (opt.data || [{"value":val, "text":val}]); _.each(data, function(item){ var selected = item.value == val ? "selected" : "";%>' +
				'<option value="<%- item.value%>" <%- selected%> ><%- t(item.text)%></option>\n<%});%></select><div id="<%-name%>_validation" class="validation_image"></div></div>',
			CHECKBOX: '<% var opt = {lbl_txt: t(label), checked: (value == "true" ? "checked" : ""), validate: 1}; %>' +
				'<div class="row <%-name%> drf_checkbox_wrap"><input class="directFlowCheckbox <%-name%>" type="checkbox" id="<%-name%>" name="<%-name%>" value="true" <%-opt.checked%> ><label for="<%-name%>"><span class="text" data-no="<%-t("checkbox_no")%>" data-yes="<%-t("checkbox_yes")%>"></span><%= opt.lbl_txt%></label><% if(opt.validate){%><div id="<%-name%>_validation" class="validation_image"></div><%}%></div>',
			BUTTON: '<div class="row <%-name%>"><button type="button" role="button" id="<%-name%>" class="btn <%-name%>" data-action="<%-action%>"><%- t(label)%></button></div>',
			HIDDEN: '<div class="row_hidden <%-name%> hidden"><input type="hidden" id="<%-name%>" class="<%-name%> hidden" name="<%-name%>" value="<%-value%>" /></div>',
			DEFAULT: defaultTemplate
		};
		if (fld_type === "HIDDEN") {
			return _.template(tpl[fld_type]);
		} else if (custom_tpl.length) {
			return _.template(custom_tpl.text());
		}
		return _.template(tpl[fld_name] || tpl[fld_type] || tpl['DEFAULT']);
	}

	function getExtraDetailsHtml(renderData, data) {
		var fld_maxlength = {};
		var html = '';
		_.each(_.keys(renderData), function (fieldName) {
			var payload = _.clone(renderData[fieldName]);
			payload.skipMaxlengthAttr || (payload.skipMaxlengthAttr = false);
			payload.maxlength || (payload.maxlength = (fld_maxlength[fieldName] || 70));
			payload.normalizedData = _.clone(renderData);
			payload.disabled = (renderData[fieldName].visibilityMode === "DISABLED" ? 'readonly' : "");
			payload.action = (payload.action || ((payload.inputType || '').toUpperCase() === 'BUTTON' ? payload.value : ""));
			payload.dropDownOptions = payload.dropDownOptions || [];
			if (renderData[fieldName].visibilityMode === "HIDDEN") {
				payload.inputType = "HIDDEN";
			}
			html += utils.getExtraDetailsFieldTemplate(fieldName, payload.inputType)(payload);
		});
		return html;
	}

	function confirmNoRegistrationNeeded(data, extraData, pmUniqueId) {
		var def = new $.Deferred();

		if (extraData
			&& extraData.uniqueId === app.lastSelectedMethodId
			&& (extraData.command === "registerUser"
				|| extraData.command === "displayErrorMessage"
				|| extraData.command === "redirect")
		) {
			def.reject(extraData);
		} else if (pmUniqueId === app.lastSelectedMethodId) {
			def.resolve(data);
		} else {
			def.reject('flowInterrupted');
		}
		return def.promise();
	}
	/** =============== </ExtraDetails> =============== **/


	/** =============== <USER Registration> =============== **/
	function registerUser(pmUniqueId, pmName) {
		return utils.getFieldsForRegistration(pmName, pmUniqueId)
			.then(app.util.showRegistrationScreen);
	}

	function getFieldsForRegistration(pmType, pmUniqueId) {
		/** someday this will become an ajax call */
		var def = new $.Deferred();
		var data = $.extend(true, {paymentMethodName:pmType}, ((window.defaults && window.defaults.enrollmentData) || window.enrollmentData || {})[pmType]);
		_.each(data.fields, function (item) {
			if (item.value && item.visibilityMode != "HIDDEN") {
				item.visibilityMode = "HIDDEN"; // "DISABLED";
			}
		});
		def.resolve(data);
		return def.promise();
	}

	function getRegistrationScreenPayload(data, userName) {
		var header_html = _.template(
			'<%if(greeting) {%> <div class="greeting"><%= t(greeting, [user])%></div>' +
			'<%} if(info) {%> <div class="info"><%= t(info)%></div>' +
			'<%} if(h_2) {%> <div class="reg_h2"><%= t(h_2)%></div><%}%>'
		)({
			greeting: data.greeting,
			info: data.registration_info,
			h_2: data.registration_h2,
			user: userName
		});
		var payload = {
			titleKey: (data.registration_title || 'registration_title'), // (pmName + "_registration_title"),
			header: header_html,
			msgArr: ['<div class="details">' + utils.getExtraDetailsHtml(data.fields) + '</div>'],
			confirmBtn: {
				isVisible: true,
				txt: data.register_user_btn_txt || 'register_user_btn',
			},
			cancelBtn: {
				isVisible: true,
				txt: "lightbox_cancel_button"
			}
		};
		return payload;
	}

	function collectRegistrationData(data) {
		var dataToSend = {};
		_.each(data, function (item) {
			if (item && item.inputType !== "BUTTON") {
				dataToSend[item.name] = $('#' + item.name).val();
			}
		})
		return dataToSend;
	}
	/** =============== </USER Registration> =============== **/


	/** =============== <ACCOUNT Registration> =============== **/
	function getFieldsForAddingBankAccount(pmType, pmUniqueId) {
		/** someday this will become an ajax call */
		var def = new $.Deferred();
		var pmData = ((window.defaults && window.defaults.enrollmentData) || window.enrollmentData || {})[pmType];
		var data = {paymentMethodName: pmType};
		if (pmData && pmData.fields) {
			var usr_bankAccount = $.extend(true, {}, pmData.fields.usr_bankAccount);
			usr_bankAccount.value = '';
			var confirm_bankAccount = $.extend(true, {}, usr_bankAccount);
			confirm_bankAccount.name = 'confirm_bankAccount';
			confirm_bankAccount.label = 'confirm_bankAccount';
			var usr_bankCode = $.extend(true, {}, pmData.fields.usr_bankCode);
			usr_bankCode.value = '';

			data.fields = {
				usr_bankAccount: usr_bankAccount,
				confirm_bankAccount: confirm_bankAccount,
				usr_bankCode: usr_bankCode
			};
			def.resolve(data);
		}
		return def.promise();
	}

	function getAddAccountScreenPayload(data) {
		var payload = {
			titleKey: 'lightbox_title_add_account',
			header: '',
			msgArr: ['<div class="details">' + utils.getExtraDetailsHtml(data.fields) + '</div>'],
			confirmBtn: {isVisible: true, txt: 'lightbox_add_account_button'},
			cancelBtn: {isVisible: true, txt: 'lightbox_cancel_button'}
		};
		return payload;
	}
	/** =============== </ACCOUNT Registration> =============== */

	function createWholeScreenOverlay (className) {
		var $elm = $('#whole_screen_overlay');
		if (!$elm.length) {
			$elm = $('<div id="whole_screen_overlay" style="/*position: fixed; z-index: 2;top: 0;left: 0;height: 100%;width: 100%; background-color: rgba(10, 10, 10, 0.2);*/"></div>');
			$('body').append($elm);
		}
		$elm.removeClass().addClass("whole_screen_overlay " + (className || ''));
		return $elm;
	}

	var pwmb = (function () {
		var _g, cfg;
		var CONST = {
			// PWMB_PM_NAME : 'apmgw_Online_Banking',
			PWMB_UPO_NAME_DELIMITER: '-|-',
			WIDGET_FRAME: {
				NAME: 'sfc_paywithmybank_widget_iframe',
				EXTRA_CLASS: '_invisible',
				MAX_HEIGHT: 800
			},
			LBX_FRAME: {
				NAME: 'sfc_paywithmybank_lbx_iframe',
				EXTRA_CLASS: 'overall'
			},
			STATE: {
				IFRAME_READY: 1,
				SDK_READY: 2,
				WIDGET_LOADING: 3,
				WIDGET_READY: 4,
				LBX_LOADING: 5,
				LBX_READY: 6
			}
		};
		var defaults =  {
			_env                : "PROD",
			_msgsOutputElmHeight: 0,
			_currency			: 'USD',
			logoUrl 			: "https://paywithmybank.com/start/assets/institutions/icons/{0}.png",
			// paymentType         : "Deferred",
			// pwmbSdkUrl          : "https://sandbox.paywithmybank.com/start/scripts/paywithmybank.js?accessId=xxxxxxx",
			// proxyIframeUrl      : "../../../webapp/resources/cdn/v1/pwmb_ifrm.html",
			PayWithMyBankOptions : {
				hideCloseButton     : false,
				hideSelectBankBack  : false,
				dragAndDrop         : false,
				widgetContainerId   : "pwmb_widget_container"
			},
			customer : {}
		};
		var _pubsubSubscribeObj = false;

		function init(config) {
			cfg = $.extend(true, {}, defaults, config);
			_g = {
				_iframeOutputElmHeight : ((cfg._env === "DEV") ? cfg._msgsOutputElmHeight : 0),
			};
			_g[CONST.WIDGET_FRAME.NAME] = {};
			_g[CONST.LBX_FRAME.NAME] = {};
			var errors = getCfgErrors();
			if(errors.length){
				console.error('INVALID PWMB CONFIG PARAMS:', JSON.stringify(errors));
			}
			if(!_pubsubSubscribeObj) {
				_pubsubSubscribeObj = pubsub.subscribe('safecharge.PWMB.authorization.ready', function (data) {
					if (data
						&& data.trxStatus !== 'CANCELLED'
						&& data.uniqueId
						&& data.uniqueId.toString() === (app.lastSelectedMethodId || '').toString()
						&& data.details) {
						removeLbxAndOverlay();
					} else {
						onLbxCancelled();
					}
				});
			}
		}

		function getCfgErrors() {
			var props = ["accessId", "merchantId", "merchantName", "merchantReference", "description", "pwmbSdkUrl",
				"proxyIframeUrl", "paymentType",/* "customer.externalId",*/ "customer.name", "customer.taxId"];
			var errors = [];
			_.each(props, function (prop) {
				var propArr = prop.split('.');
				var val;
				if (propArr.length === 2) {
					val = _.isObject(cfg[propArr[0]]) && cfg[propArr[0]][propArr[1]];
				} else {
					val = cfg[prop];
				}
				if (!val) {
					errors.push(prop);
				}
			});
			return errors;
		}

		function getPostMessenger(iFrameId) {
			var iframe =  $('#'+iFrameId).get(0).contentWindow;
			return function postMsg(sendObj){
				iframe.postMessage(JSON.stringify(sendObj), '*');
			}
		}

		function getPwmbEstablishData() {
			var data = {
				"accessId"          : cfg.accessId,
				"merchantId"        : cfg.merchantId,
				"merchantReference" : cfg.merchantReference,
				"amount"            : '0.00',                           // OR (app.lastSelectedAmount).toFixed(2),
				"currency"          : (app.currency || cfg._currency),  // OR 'USD',
				"description"       : cfg.description,
				"returnUrl"         : utils.addQueryStringParams(cfg.returnUrl,{"uniqueId":  app.lastSelectedMethodId}), // cfg.returnUrl,
				"cancelUrl"         : utils.addQueryStringParams(cfg.cancelUrl,{"uniqueId":  app.lastSelectedMethodId}), // cfg.cancelUrl,
				"paymentType"       : cfg.paymentType
			}
			data.customer = cfg.customer;
			return data;
		}

		function loadPwmbSDK(iFrameId) {
			var postMsg = _g[iFrameId] && _g[iFrameId].postMsg;
			if(postMsg && typeof postMsg =='function') {
				postMsg({
					action: 'loadPwmbScript',
					data: {
						url: cfg.pwmbSdkUrl,
						env: cfg._env,
						uniqueId: app.lastSelectedMethodId,
						msgsOutputElmHeight: _g._iframeOutputElmHeight
					}
				});
			}
		}

		function loadPwmbWidget(iFrameId) {
			if(_g[iFrameId].state === CONST.STATE.SDK_READY) {
				setIframeState(iFrameId, CONST.STATE.WIDGET_LOADING);
				var postMsg = _g[iFrameId] && _g[iFrameId].postMsg;
				if(postMsg && typeof postMsg =='function') {
					var dataToSend = {
						trxData : getPwmbEstablishData(),
						PayWithMyBankOptions: cfg.PayWithMyBankOptions
					};
					dataToSend.trxData.amount = null;
					postMsg({action: 'loadPwmbWidget', data: dataToSend});
				}
			}
		}

		function loadPwmbLbx(iFrameId) {
			if (_g[iFrameId].state === CONST.STATE.SDK_READY) {
				setIframeState(iFrameId, CONST.STATE.LBX_LOADING);
				var postMsg = _g[iFrameId] && _g[iFrameId].postMsg;
				if (postMsg && typeof postMsg == 'function') {
					var dataToSend = {
						// uniqueId: app.lastSelectedMethodId, // NOT important here!
						trxData: getPwmbEstablishData(),
						PayWithMyBankOptions: cfg.PayWithMyBankOptions
					};
					if(_g._store) {
						dataToSend.trxData.paymentProviderId = _g._store.paymentProviderId;
						dataToSend.trxData.deviceType = _g._store.deviceType;
						// dataToSend.trxData.dynamicWidget = _g._store.dynamicWidget; // ???
					} else if(cfg.paymentProviderId){
						dataToSend.trxData.paymentProviderId = cfg.paymentProviderId;
					}
					signAndContinue(dataToSend.trxData, function () {
						postMsg({action: 'loadPwmbLbx', data: dataToSend});
					});
				}
			}
		}

		function loadPwmbWidgetOrLbx(iFrameId) {
			if (iFrameId === CONST.WIDGET_FRAME.NAME) {
				loadPwmbWidget(iFrameId)
			} else if (iFrameId === CONST.LBX_FRAME.NAME) {
				loadPwmbLbx(iFrameId)
			}
		}

		function setIframeState(iFrameId, state) {
			if (iFrameId && _g[iFrameId]) {
				_g[iFrameId].state = state;
			}
		}

		function setIframeOrigin(iFrameId, origin) {
			if (iFrameId && _g[iFrameId]) {
				_g[iFrameId].origin = origin;
			}
		}

		function setIframePostMessenger(iFrameId) {
			_g[iFrameId].postMsg = getPostMessenger(iFrameId);
		}

		function createIFrame(iFrameId, src, opt) {
			var iframe = $('#' + iFrameId).get(0);
			if (iframe) {
				iframe.setAttribute("src", src);
				return iframe;
			}
			var _defaults = {
				title: "",
				scrolling: "auto", //"yes", // "no",
				extraClassName: '' // 'overall'
			};
			var o = $.extend(true, _defaults, opt);
			o.className = iFrameId + (o.extraClassName? ' ' + o.extraClassName: '');

			iframe = document.createElement("iframe");
			iframe.setAttribute("id", iFrameId);
			iframe.setAttribute("name", iFrameId);
			iframe.setAttribute("src", src);
			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("class", o.className);
			iframe.setAttribute("scrolling",o.scrolling);
			iframe.setAttribute("title", o.title);
			/** we set "allow-same-origin" (this may lead to a security issue).
			 *  If not set - pwmb_widget works, but pwmb_lightbox doesn't work !???
			 *  so we keep it (temporary) **/
			iframe.setAttribute("sandbox", "allow-modals allow-forms allow-scripts allow-same-origin allow-popups");
			return iframe;
		}

		function renderIframe(iFrameId, selector, extraClassName) {
			var opt = {extraClassName: extraClassName};
			var frm = createIFrame(iFrameId, cfg.proxyIframeUrl, opt);
			$(selector).append(frm);
		}

		function renderWidget(selector) {
			if (_g[CONST.WIDGET_FRAME.NAME] && !_g[CONST.WIDGET_FRAME.NAME].state) {
				renderIframe(CONST.WIDGET_FRAME.NAME, selector, CONST.WIDGET_FRAME.EXTRA_CLASS);
			}
		}

		function renderLbx() {
			if (_g[CONST.LBX_FRAME.NAME] && !_g[CONST.LBX_FRAME.NAME].state) {
				utils.createWholeScreenOverlay("pwmb_overlay");
				renderIframe(CONST.LBX_FRAME.NAME, '#whole_screen_overlay', CONST.LBX_FRAME.EXTRA_CLASS);
			}
		}

		function resizeWidgetIframe(id, h) {
			if (h == 0) { // handle "PayWithMyBank.changeWidgetHeight|0"
				$('#' + id).removeClass(CONST.WIDGET_FRAME.EXTRA_CLASS);
			} else if (h && _.isNumber(h) && 0 < h && h < CONST.WIDGET_FRAME.MAX_HEIGHT) {
				$('#' + id).height(h + _g._iframeOutputElmHeight + 5).removeClass(CONST.WIDGET_FRAME.EXTRA_CLASS);
				app.recalcUserDetailsArea();
			}
		}

		function clearDom() {
			$('#' + CONST.WIDGET_FRAME.NAME + ', #' + CONST.LBX_FRAME.NAME + ', #whole_screen_overlay').remove();
			_g = {};
		}

		function removeLbxAndOverlay() {
			_g[CONST.LBX_FRAME.NAME] = {};
			$('#' + CONST.LBX_FRAME.NAME + ', #whole_screen_overlay').remove();
		}

		function storeSelectedPaymentProviderId(trxData) {
			if(trxData && trxData.paymentProviderId){
				_g._store = trxData;
			}
		}

		function signAndContinue(dataToSign, callback) {
			var pmType = isNaN(parseInt(app.lastSelectedMethodId)) ? "pm" : "upo";
			var dataToSend = {
				uniqueId: app.lastSelectedMethodId,
				type: pmType,
				dataToSign: dataToSign
			};
			var url = "/ppp/signature.do";
			$.ajax({
				type: "POST",
				url: utils.addQueryStringParams(url, {"ssid": app.config.ssid}),
				data: JSON.stringify(dataToSend),
				contentType: 'application/json',
				dataType: 'json',
				timeout: 10000
			}).done(function (res) {                            // console.log("requestSignature: ", res, dataToSign);
				if(res && res.signature) {
					dataToSign.requestSignature = res.signature;
					callback(dataToSign);
				} else {
					console.log("signature.do => missing res.signature !");
					onLbxCancelled();
				}
			}).fail(function (err){
				console.log("signature.do ERROR!", err && err.statusText);
				onLbxCancelled();
				});
		}

		function onLbxCancelled() {
			removeLbxAndOverlay();
			pubsub.publish('safecharge.PWMB.lbx.cancelled',[]);
		}

		function onMessage(res, origin) {                       // console.log(">>>>>> onMessage origin: ", origin, res);
			if (res && res.action === "sfc_pwmb_iFrame_ready"
				&& res.iframeName
				&& _g[res.iframeName]
				&& !_g[res.iframeName].origin
				&& !_g[res.iframeName].state) {
				setIframeOrigin(res.iframeName, origin);
				setIframeState(res.iframeName, CONST.STATE.IFRAME_READY);
				setIframePostMessenger(res.iframeName);
				loadPwmbSDK(res.iframeName);
			} else if (!res || res.uniqueId !== app.lastSelectedMethodId) {
				return;
			} else  if (res.action === "sfc_pwmb_bankSelected"
				&& res.iframeName === CONST.WIDGET_FRAME.NAME
				&& _g[res.iframeName].state === CONST.STATE.WIDGET_READY) {
				storeSelectedPaymentProviderId(res.data);
			} else if (res.action === "sfc_pwmb_proxy"
				&& res.iframeName
				&& _g[res.iframeName].origin === origin) {
				if (res.data === "PayWithMyBank.loaded"
					&& _g[res.iframeName].state === CONST.STATE.IFRAME_READY) {
					setIframeState(res.iframeName, CONST.STATE.SDK_READY);
					loadPwmbWidgetOrLbx(res.iframeName);
				} else  if (res.data === "PayWithMyBank.assetsLoaded"
					&& res.iframeName === CONST.LBX_FRAME.NAME
					&& _g[res.iframeName].state === CONST.STATE.LBX_LOADING) {
					setIframeState(res.iframeName, CONST.STATE.LBX_READY);
				} else if (res.data === "PayWithMyBank.closePanel" /* !== "PayWithMyBank.closePanel|..." */
					&& res.iframeName === CONST.LBX_FRAME.NAME) {
					/** an error occurred! */
					onLbxCancelled();
				} else if (typeof res.data == "string") {
					if (res.data.startsWith("PayWithMyBank.widgetLoaded")
						&& res.iframeName === CONST.WIDGET_FRAME.NAME
						&& _g[res.iframeName].state === CONST.STATE.WIDGET_LOADING) {
						setIframeState(res.iframeName, CONST.STATE.WIDGET_READY);
					} else if (res.data.startsWith("PayWithMyBank.changeWidgetHeight|")
						&& res.iframeName === CONST.WIDGET_FRAME.NAME) {
						resizeWidgetIframe(res.iframeName, parseInt(res.data.split('|')[1]));
					} else if (res.data.startsWith("PayWithMyBank.closePanel|")
						&& res.iframeName === CONST.LBX_FRAME.NAME) {
						/** we have return URL  */
						// var retUrl = res.data.split('|')[1];
					}
				}
			}
		}

		function _parseUpoName(name) {
			if (name) {
				var splitDetails = name.split(CONST.PWMB_UPO_NAME_DELIMITER).map(function (d) {
					return (d || '').trim();
				});
				return {
					accountId: splitDetails[0],
					bankName: splitDetails[1],
					providerId: splitDetails[2],
					accountType: splitDetails[3]
				};
			}
		}

		function _getMetadata(pwmbDetails) {
			if (pwmbDetails && pwmbDetails.providerId) {
				var logoUrl = (cfg && cfg.logoUrl) || defaults.logoUrl;
				return {
					"imgContentType": "png",
					"altText": "bankLogo",
					"imgMimeType": "url",
					"imgContent": logoUrl.replace('{0}', pwmbDetails.providerId)
				};
			}
		}

		function formatSrvData(item, name) {
			if (item && name) {
				item.pwmbDetails = _parseUpoName(name);
				item.name = '*' + item.pwmbDetails.accountId;
				item.upoName = '*' + item.pwmbDetails.accountId;
				item.metadata = _getMetadata(item.pwmbDetails);

				item.multilineData = {
					tooltip: item.pwmbDetails.bankName + " | *" + item.pwmbDetails.accountId + " | " + item.pwmbDetails.accountType,
					title: item.pwmbDetails.bankName,
					subtitle: item.upoName + " - " + item.pwmbDetails.accountType,
					mobileTitle: item.upoName
				}
			}
			return item;
		}

		return {
			init				: init,
			renderWidget		: renderWidget,
			renderLbx			: renderLbx,
			onMessage			: onMessage,
			removeLbxAndOverlay : removeLbxAndOverlay,
			clearDom			: clearDom,
			formatSrvData		: formatSrvData
		};

	})()

	function filterPhoneCodesByPm (codes, pmName){
		codes || (codes = app.phoneCodes || []);
		var filtered;
		var unSupported = {
			'apmgw_MuchBetter': ["+4", "+192", "+232", "+231", "+324", "+364", "+368", "+417", "+434", "+410", "+728", "+144", "+736", "+780", "+788", "+548", "+706", "+887"]
		};
		var supported = {
			'apmgw_Aircash': ["+30", "+31", "+32", "+34", "+351", "+352", "+353", "+356", "+357", "+358", "+359", "+36", "+370", "+371", "+372", "+381", "+382", "+383", "+385", "+386", "+387", "+389", "+39", "+40", "+420", "+421", "+43", "+45", "+46", "+48", "+49", "+599"], // add more if needed
			'apmgw_Fonix': ["+44"],
			'apmgw_MercadoPago': ["+51", "+52", "+54", "+55", "+56", "+57"],
			'apmgw_MBWAY': ["+351"],
			'apmgw_OnShop': ["+39"],
			'apmgw_PIX': ["+55"],
			'apmgw_Swish': ["+46"],
			'apmgw_TouchnGo': ["+60"],
			'apmgw_BancomatPay': ["+39", "+30", "+31", "+32", "+33", "+34", "+351", "+352", "+353", "+354", "+356", "+357", "+358", "+359", "+36", "+370", "+371", "+372", "+385", "+386", "+40", "+420", "+421", "+423","+43", "+45", "+46", "+47","+48", "+49"], // add more if needed
		};
		if(supported[pmName] && supported[pmName].length){
			filtered = (codes).filter(function (c) {
				return (supported[pmName].includes(c.phoneCode));
			});
		} else if(unSupported[pmName] && unSupported[pmName].length) {
			filtered = (codes).filter(function (c) {
				return !(unSupported[pmName].includes(c.phoneCode) || c.phoneCode === '');
			});
		} else {
			filtered = codes;
		}

		var phoneCodes = filtered.map(function (c) {
			return {
				phoneCode : c.phoneCode.replace('+', '').replace(" ",""),
				iso       : c.iso,
				name      : c.name
			};
		}).sort(function (a, b) {
			return a.phoneCode > b.phoneCode ? 1 : a.phoneCode < b.phoneCode ? -1 : 0;
		});
		phoneCodes = _.uniq(phoneCodes, function (c) {
			return c.phoneCode;
		});
		phoneCodes.unshift("");
		return phoneCodes;
	}

	/**
	 * @param payload  = {
	 * 		msgArr: [msg1, msg2,...],
	 * 		type:  'info' | 'warning' | string
	 * }
	 * @param wrapper_selector - CSS selector
	 */
	function showInlineMessage (payload, wrapper_selector){
		var $wrapper = $(wrapper_selector || '#inline_info_msg');
		if (!$wrapper.length) {
			$wrapper = $('<div id="inline_info_msg"></div>');
			$('.PMINFO').prepend($wrapper);
		}
		var template = '<div class="inline_info_wrapper <%- message.type %>">' +
			'<div class="<%- message.type%>_icon ii_icon"></div><div class="ii_msg_container">' +
			'<% _.each(message.msgArr || [], function(v){%><div class="ii_msg"><%= t(v)%></div><%});%>' +
			'<span class="ii_close_btn"></span></div>' +
			'</div>';

		var $html = $(_.template(template)({message:payload})).attr('data-role', 'inline_info_msg');

		$wrapper.html($html);
		$wrapper.find('.ii_close_btn').on('click', function () {
			$wrapper.empty();
			app.recalcUserDetailsArea();
			pubsub.publish('inlineMessage.closed',[payload]);
		});
	}

	function notifyCardUpdateMessageClosed (payload) {
		var payloadOnClose = {
			uniqueId: payload.uniqueId,
			ssid: app.config.ssid
		};

		$.ajax({
			type: 'POST',
			url: "/ppp/api/cardUpdateMessageCancel.do",
			data: JSON.stringify(payloadOnClose),
			contentType: "application/json",
			dataType: "json",
			error: function() {
				console.log('Card update request error. Unable to perform operation!');
			}
		});
	};

	function notifyCancelOrderForBeneficiaryOwner(isWD) {
		return $.post('/ppp/cancelOrderForBeneficiaryOwner.do?ssid=' + app.config.ssid, {
				ssid: app.config.ssid,
				// msid: (isWD ? app.config.merchant_site_id : app.config.msid)
				amount: (isWD ? app.config.wd_amount : app.lastSelectedAmount),
				currency: app.lastSelectedCurrency,
				uniqueId: app.lastSelectedMethodId,
				workflowType: (isWD ? 'WITHDRAW' : 'DEPOSIT'),
				paymentMethod: (isWD ? app.current_pm_name : app.lastSelectedMethodType)
			}
		);
	}

	function createSuspendedPmBlocker(blockerKey, blockerMsg) {
		var msg = blockerMsg || _.template('<div><%=t("suspended_pm_title")%></div><br><div><%=t("suspended_pm_message")%></div>')();
		var blocker = {};
		blocker[blockerKey || "message1"] = msg;
		return blocker;
	}

	function useDualCardBrands() {
		return app.config.useDualCardBrands || app.lastSelectedMethodId === 'bancontact_cc_card';
	}

	var MaskedAmount = (function initMaskedAmount () {
		var maskElm,
			isFirstInvocation = true,
			MA = {};
		var options = {
		    numeral: true,
		    numeralThousandsGroupStyle: 'thousand', // 'thousand' | 'wan' | 'lakh' | 'none' | 'fourDigitsWithoutDelimiter'
		    numeralIntegerScale: 5,
		    numeralDecimalScale: 2,
		    numeralDecimalMark: '.',
		    numeralPositiveOnly: true,
		    delimiter: ' '
		};
		var wanLocales = {};
		var lakhLocales = {
			'en_IN': true,
			'hi_IN': true
		};

        MA.shouldInitMaskedAmount = function () {
			if(!app.config.useMaskedAmount) {
				return false;
			}
			if(!window.Cleave) {
				console.log('OpenAmountFormatting: Cleave library missing');
				return false;
			}
			if(!app.config.useIntlFormatter) {
				console.log('OpenAmountFormatting: useIntlFormatter is not enabled');
				return false;
			}
			return true;
		}

		MA.init = function (isWD) {
			options.isWD = isWD;

			if(!MA.shouldInitMaskedAmount()) {
				return;
			}
			if(isFirstInvocation) {
				$(document).on('input change', '#masked_item_amount_1', function (ev){
					var ev_type = ev.type;
					var isUserChange = ev.originalEvent !== undefined;
					if(isUserChange) {
						var val = MA.getUnmaskedValue();
						if(val && val[0] === '.' && val.length > 1) {
							val = '0' + val;
						}
						if(val && val[val.length - 1] === '.') {
							val = val.replace('.', '');
						}
						var eventsArr = ['maskedAmountUserInput'];
						if(ev_type === "change")  {
							eventsArr = ['blur', 'change', 'maskedAmountUserChange'];
						}
						app.util.setAmountValue(val, eventsArr, 'maskedAmount');
					}
				});
				isFirstInvocation = false;
			}

			var setValue = function (val) {
				return MA.setValue(val);
			}

			return {
				"createMask":                     MA.createMask,
				// "destroyMask":                 MA.destroyMask,
				// "getMaskElm":                  MA.getMaskElm,
				"setValue":                       setValue,
				// "getUnmaskedValue":            MA.getUnmaskedValue
			};
		}

		MA.getIntlFormatterSeparators = function () {
			var pattern = /[0-9\u0660-\u0669]/g; // matches digits from 0 - 9 and arabic digits from 0 - 9

		    return {
		        decimalSeparator: app.formatter.formatDecimal(0.20).replace(pattern, ''),
		        thousandsSeparator: app.formatter.formatDecimal(100000000).replace(pattern, '')[0],
		    } 
		}
		MA.getIntlFormatterPrecision = function () {
			var precisionMap = {};

			try {
				var formatterConfigJson = JSON.parse(app.formatter.showConfig());
				if(formatterConfigJson) {
					precisionMap = formatterConfigJson.rounding;
				}
			} catch (err) {
				console.log(err);
			}

			return precisionMap;
		}
		MA.shouldUsefourDigitsWithoutDelimiter = function () {
			var pattern = /[0-9\u0660-\u0669]/g;
			var hasDelimiter = app.formatter.formatDecimal(9999).replace(pattern, '');

			return hasDelimiter ? false : true;
		}

		MA.createMask = function (params) { 
			if(!$("#masked_item_amount_1").length) {
				console.log('masked amount elm missing');
				return;
			}

			var locale = options.isWD ? app.config.merchantLocale : app.locale;
			if(wanLocales[locale]) {
				options.numeralThousandsGroupStyle = 'wan';
			}
			if(lakhLocales[locale]) {
				options.numeralThousandsGroupStyle = 'lakh';
			}

		    var separators = MA.getIntlFormatterSeparators();
		    options.numeralDecimalMark = separators.decimalSeparator;
		    options.delimiter = separators.thousandsSeparator;

			if(!isNaN(parseInt(app.roundingScale))) {
				options.numeralDecimalScale = app.roundingScale;
			} else {
				var currency = options.isWD ? app.config.wd_currency  : app.lastSelectedCurrency;
				var precisionMap = MA.getIntlFormatterPrecision();
				if(precisionMap[currency] !== undefined) {
					options.numeralDecimalScale = precisionMap[currency];
				}
			}

			if(MA.shouldUsefourDigitsWithoutDelimiter()) {
				options.numeralThousandsGroupStyle = 'fourDigitsWithoutDelimiter';
			}

			options.numeralIntegerScale = params.maxLength;

		    MA.destroyMask();

		    maskElm = new Cleave('#masked_item_amount_1', options);
			var amountElmValue = options.isWD ? $('input.amount').val() : $('#item_amount_1').val();
			var amountElmDecimalSeparator = '.';
			var amountElmParts = amountElmValue && amountElmValue.split(amountElmDecimalSeparator);
			var amountIntegerScale = amountElmParts && amountElmParts[0] && amountElmParts[0].length;

			if(amountIntegerScale && amountIntegerScale <= options.numeralIntegerScale) {
				MA.setValue(amountElmValue);
			}
		}

		MA.destroyMask = function () {
		    if(maskElm) {
				MA.setValue('', true);
		        maskElm.destroy();
		    }
		}

		// MA.getMaskElm = function () {
		//     return maskElm;
		// }

		MA.setValue = function (val, shouldSkipAmountCheck) {
		    if(maskElm && (val || val === "" || val === 0)) {
				var amountElmValue = options.isWD ? $('input.amount').val() : $('#item_amount_1').val();
				var newValStr = val.toString();
				if(shouldSkipAmountCheck || (newValStr === amountElmValue)) {
					maskElm.setRawValue(newValStr);
				}
		    }
		}

		MA.getUnmaskedValue = function () {
		    if(!maskElm) {
		        return;
		    }
		    return maskElm.getRawValue();
		}

		return {
			"init": MA.init
		};
	}());

	return {
		checks:{
            alwaysFalse             : alwaysFalse,
			notEmpty                : notEmpty,
			minlength               : minlength,
			maxlength               : maxlength,
			maxFractionLength       : maxFractionLength,
			exactlength             : exactlength,
			exactlengthCompositePhoneWithoutCode: exactlengthCompositePhoneWithoutCode,
			digitsOnly              : digitsOnly,
			digitsOnlyOrEmpty		: digitsOnlyOrEmpty,
			alphanumeric            : alphanumeric,
			inRange                 : inRange,                     // (value, params{max, min, msg})
			nonZeroNumberStart      : nonZeroNumberStart,
			atLeastTwoNonZeroDigits : atLeastTwoNonZeroDigits,
			fortunaMod11ChechBanks	: fortunaMod11ChechBanks,
			cc_minlength            : cc_minlength,
			cc_maxlength            : cc_maxlength,
			cc_expiration           : cc_expiration,
			creditcard              : creditcard,
			isCardAcceptable        : isCardAcceptable,
			isCardNumber			: isCardNumber,
			isValidCardNumber       : isValidCardNumber,
			exceedsCreditCardDepositLimit: exceedsCreditCardDepositLimit,
			testPlayPlusBalance     : testPlayPlusBalance,
			testOktoCashDecimalAmount: testOktoCashDecimalAmount,
			validNettelerAccount    : validNettelerAccount,
			testRegex               : testRegex,
			testZip                 : testZip,
			testDateOfBirth			: testDateOfBirth,
			testAddress             : testAddress,
			testCVV2                : testCVV2,                    // (value, params, card_type)
			testIBAN				: testIBAN,
			testIBANWithSpacesInsensitive: testIBANWithSpacesInsensitive,
			testEmail               : testEmail,
			testWBAccountId         : testWebanqAccountId,
			testWBAccountPassword   : testWebanqAccountPassword,
			noCommaSeparatedNumber  : noCommaSeparatedNumber,
			testFullName            : testFullName,
			testPaySafeName         : testPaySafeName,
			testPaySafeBirthdate    : testPaySafeBirthdate,
			testQiwiPhonenumber     : testQiwiPhonenumber,
			testPhonenumber         : testPhonenumber,
			testCompositePhone      : testCompositePhone,
			testSmart2PayPhonenumber: testSmart2PayPhonenumber,
			testMbwayPhoneNumber: testMbwayPhoneNumber,
			testCitadelSwiftCode    : testCitadelSwiftCode,
			recognizedIssuer        : recognizedIssuer,
			dateInThePast           : dateInThePast,
			testInstadebitAccountId : testInstadebitAccountId,
			testPromoCode           : testPromoCode,
			maxAmount               : maxAmount,
			custom                  : custom,
			validateCardHolderName  : validateCardHolderName,
			validateCardHolderNameOnWD : validateCardHolderNameOnWD,
			testIsraeliCardHolderID : testIsraeliCardHolderID,
			testTicketPremiumAccountId: testTicketPremiumAccountId,
			testBacsWithdrawAccountName: testBacsWithdrawAccountName,
			testAstroPayPhone       : testAstroPayPhone,
			testAstroPayPrepaidAccountId: testAstroPayPrepaidAccountId,
			testLPEAccountNumber	: testLPEAccountNumber,
			testLPEBankNumber		: testLPEBankNumber,
			testBic					: testBic,
			testWTBic				: testWTBic,
			testBrazilPersonalId    : testBrazilPersonalId,
			testPersonalId          : testPersonalId,
			isChecked				: isChecked,
			testPostFinancePayDirectFlow: testPostFinancePayDirectFlow,
			validateNppPayId     	: validateNppPayId,
			validatePayToPayId     	: validatePayToPayId,
			validatePixKey      	: validatePixKey,
			digitsAndLettersOnly	: digitsAndLettersOnly,
			testEcheckState			: testEcheckState,
			asyncCheck              : asyncCheck,
			testEcheckZip			: testEcheckZip,
			testEcheckCountry		: testEcheckCountry,
			isCurrencySupportedByTheCard 		: isCurrencySupportedByTheCard
		},
		remapCurrency           : remapCurrency,           // (currencyISO)
		formatAmount            : formatAmount,             // (value, roundingScale,thousandsSeparator)
// <TO_BE_REMOVED>
		paydotcomCardPrefixMask	: paydotcomCardPrefixMask,
		paydotcom               : paydotcom,
// </TO_BE_REMOVED>
		getCountries            : _getCountries,
		getPhoneCodes           : _getPhoneCodes,
		isValidShortIsraeliCard : _isValidShortIsraeliCard,
		handlePassiveEvents		: handlePassiveEvents,
		showToastMessage        : showToastMessage,
		setLabels               : setLabels,                // (css_input_selector /*, focused_label_class*/)
		setFloatingLabels       : setFloatingLabels,        // (css_input_selector /*, skipFloating, focused_label_class */)
		getDomModificationHandler : handleDomModification,  // ({jQ_selector: 'div[role="main"]', postObj: { name: "initial", message: "{{current_height}}" }, parent_url: "*"});
		getUserAgentInfo        : getUserAgentInfo,
        floatingLabels          : floatingLabels,
        triggerNativeResizeEvent: triggerNativeResizeEvent,
        oneRowExpDateHelper     : oneRowExpDateHelper,
        isPMBlocked             : isPMBlocked,
        renderBlockedPMReasons  : renderBlockedPMReasons,
		remapCardSupportedCurrencies: remapCardSupportedCurrencies,
		sendPostMessageFromAttr : sendPostMessageFromAttr,
		sendRefreshPagePostMessages : sendRefreshPagePostMessages,
		showVersionOnAltVTwice  : showVersionOnAltVTwice,
		showQROnAltQTwice       : showQROnAltQTwice,
		startSessionTimer       : startSessionTimer,
		restartSessionTimer     : restartSessionTimer,
		colors: {
			createColorObj       : createColorObj,
			getRelativeLuminance : getRelativeLuminance,
			getContrast          : getContrast
		},
		getColorSettings            	: getColorSettings,
		getInltFormatedCurrency     	: getInltFormatedCurrency,
		getCustomImgClassNameSuffix 	: getCustomImgClassNameSuffix,
		getCancelWdrPostMessageData 	: getCancelWdrPostMessageData,
		getCardAsyncChecker         	: getCardAsyncChecker,
		getIntlFormatter            	: getIntlFormatter,

		onTabPressFixIScrollV        	: onTabPressFixIScrollV,
		generateFieldValidationRules	: generateFieldValidationRules,

		getPmExtraDetails				: getPmExtraDetails,
		formatExtraDetails				: formatExtraDetails,
		getExtraDetailsFieldTemplate	: getExtraDetailsFieldTemplate,
		getExtraDetailsHtml				: getExtraDetailsHtml,
		confirmNoRegistrationNeeded		: confirmNoRegistrationNeeded,
		registerUser					: registerUser,
		getFieldsForRegistration		: getFieldsForRegistration,
		getRegistrationScreenPayload	: getRegistrationScreenPayload,
		collectRegistrationData			: collectRegistrationData,
		getFieldsForAddingBankAccount	: getFieldsForAddingBankAccount,
		getAddAccountScreenPayload		: getAddAccountScreenPayload,

		createSuspendedPmBlocker		: createSuspendedPmBlocker,
		createWholeScreenOverlay		: createWholeScreenOverlay,
		pwmb 							: pwmb,
		filterPhoneCodesByPm 			: filterPhoneCodesByPm,
		notifyCancelOrderForBeneficiaryOwner : notifyCancelOrderForBeneficiaryOwner,
		storeCardCredentialsHandler 	: storeCardCredentialsHandler,
		showStoreCardTerms          	: showStoreCardTerms,
		addQueryStringParams        	: addQueryStringParams,
		showInlineMessage				: showInlineMessage,
		notifyCardUpdateMessageClosed	: notifyCardUpdateMessageClosed,
		MaskedAmount		     		: MaskedAmount,
		useDualCardBrands				: useDualCardBrands
	}
})();
